/* eslint-disable */
import { languageTag } from "./runtime.js"
import * as de from "./messages/de.js"
import * as en from "./messages/en.js"
import * as es from "./messages/es.js"
import * as fr from "./messages/fr.js"
import * as it from "./messages/it.js"
import * as nl from "./messages/nl.js"
import * as pt from "./messages/pt.js"


/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__add = (params = {}, options = {}) => {
	return {
		de: de.action__add,
		en: en.action__add,
		es: es.action__add,
		fr: fr.action__add,
		it: it.action__add,
		nl: nl.action__add,
		pt: pt.action__add
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back = (params = {}, options = {}) => {
	return {
		de: de.action__back,
		en: en.action__back,
		es: es.action__back,
		fr: fr.action__back,
		it: it.action__back,
		nl: nl.action__back,
		pt: pt.action__back
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_home = (params = {}, options = {}) => {
	return {
		de: de.action__back_home,
		en: en.action__back_home,
		es: es.action__back_home,
		fr: fr.action__back_home,
		it: it.action__back_home,
		nl: nl.action__back_home,
		pt: pt.action__back_home
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_overview = (params = {}, options = {}) => {
	return {
		de: de.action__back_overview,
		en: en.action__back_overview,
		es: es.action__back_overview,
		fr: fr.action__back_overview,
		it: it.action__back_overview,
		nl: nl.action__back_overview,
		pt: pt.action__back_overview
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_to_search = (params = {}, options = {}) => {
	return {
		de: de.action__back_to_search,
		en: en.action__back_to_search,
		es: es.action__back_to_search,
		fr: fr.action__back_to_search,
		it: it.action__back_to_search,
		nl: nl.action__back_to_search,
		pt: pt.action__back_to_search
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__close_panel = (params = {}, options = {}) => {
	return {
		de: de.action__close_panel,
		en: en.action__close_panel,
		es: es.action__close_panel,
		fr: fr.action__close_panel,
		it: it.action__close_panel,
		nl: nl.action__close_panel,
		pt: pt.action__close_panel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__delete = (params = {}, options = {}) => {
	return {
		de: de.action__delete,
		en: en.action__delete,
		es: es.action__delete,
		fr: fr.action__delete,
		it: it.action__delete,
		nl: nl.action__delete,
		pt: pt.action__delete
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__edit = (params = {}, options = {}) => {
	return {
		de: de.action__edit,
		en: en.action__edit,
		es: es.action__edit,
		fr: fr.action__edit,
		it: it.action__edit,
		nl: nl.action__edit,
		pt: pt.action__edit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__modify = (params = {}, options = {}) => {
	return {
		de: de.action__modify,
		en: en.action__modify,
		es: es.action__modify,
		fr: fr.action__modify,
		it: it.action__modify,
		nl: nl.action__modify,
		pt: pt.action__modify
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__open_panel = (params = {}, options = {}) => {
	return {
		de: de.action__open_panel,
		en: en.action__open_panel,
		es: es.action__open_panel,
		fr: fr.action__open_panel,
		it: it.action__open_panel,
		nl: nl.action__open_panel,
		pt: pt.action__open_panel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__print = (params = {}, options = {}) => {
	return {
		de: de.action__print,
		en: en.action__print,
		es: es.action__print,
		fr: fr.action__print,
		it: it.action__print,
		nl: nl.action__print,
		pt: pt.action__print
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__retry = (params = {}, options = {}) => {
	return {
		de: de.action__retry,
		en: en.action__retry,
		es: es.action__retry,
		fr: fr.action__retry,
		it: it.action__retry,
		nl: nl.action__retry,
		pt: pt.action__retry
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__save = (params = {}, options = {}) => {
	return {
		de: de.action__save,
		en: en.action__save,
		es: es.action__save,
		fr: fr.action__save,
		it: it.action__save,
		nl: nl.action__save,
		pt: pt.action__save
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__save_close = (params = {}, options = {}) => {
	return {
		de: de.action__save_close,
		en: en.action__save_close,
		es: es.action__save_close,
		fr: fr.action__save_close,
		it: it.action__save_close,
		nl: nl.action__save_close,
		pt: pt.action__save_close
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__sign_in = (params = {}, options = {}) => {
	return {
		de: de.action__sign_in,
		en: en.action__sign_in,
		es: es.action__sign_in,
		fr: fr.action__sign_in,
		it: it.action__sign_in,
		nl: nl.action__sign_in,
		pt: pt.action__sign_in
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__sign_up = (params = {}, options = {}) => {
	return {
		de: de.action__sign_up,
		en: en.action__sign_up,
		es: es.action__sign_up,
		fr: fr.action__sign_up,
		it: it.action__sign_up,
		nl: nl.action__sign_up,
		pt: pt.action__sign_up
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__validate = (params = {}, options = {}) => {
	return {
		de: de.action__validate,
		en: en.action__validate,
		es: es.action__validate,
		fr: fr.action__validate,
		it: it.action__validate,
		nl: nl.action__validate,
		pt: pt.action__validate
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__article_button = (params = {}, options = {}) => {
	return {
		de: de.ad__magazine__article_button,
		en: en.ad__magazine__article_button,
		es: es.ad__magazine__article_button,
		fr: fr.ad__magazine__article_button,
		it: it.ad__magazine__article_button,
		nl: nl.ad__magazine__article_button,
		pt: pt.ad__magazine__article_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__badge_text = (params = {}, options = {}) => {
	return {
		de: de.ad__magazine__badge_text,
		en: en.ad__magazine__badge_text,
		es: es.ad__magazine__badge_text,
		fr: fr.ad__magazine__badge_text,
		it: it.ad__magazine__badge_text,
		nl: nl.ad__magazine__badge_text,
		pt: pt.ad__magazine__badge_text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__button_label = (params = {}, options = {}) => {
	return {
		de: de.ad__magazine__button_label,
		en: en.ad__magazine__button_label,
		es: es.ad__magazine__button_label,
		fr: fr.ad__magazine__button_label,
		it: it.ad__magazine__button_label,
		nl: nl.ad__magazine__button_label,
		pt: pt.ad__magazine__button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__first_line = (params = {}, options = {}) => {
	return {
		de: de.ad__magazine__first_line,
		en: en.ad__magazine__first_line,
		es: es.ad__magazine__first_line,
		fr: fr.ad__magazine__first_line,
		it: it.ad__magazine__first_line,
		nl: nl.ad__magazine__first_line,
		pt: pt.ad__magazine__first_line
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_button = (params = {}, options = {}) => {
	return {
		de: de.ad__magazine__generic_button,
		en: en.ad__magazine__generic_button,
		es: es.ad__magazine__generic_button,
		fr: fr.ad__magazine__generic_button,
		it: it.ad__magazine__generic_button,
		nl: nl.ad__magazine__generic_button,
		pt: pt.ad__magazine__generic_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_subtitle = (params = {}, options = {}) => {
	return {
		de: de.ad__magazine__generic_subtitle,
		en: en.ad__magazine__generic_subtitle,
		es: es.ad__magazine__generic_subtitle,
		fr: fr.ad__magazine__generic_subtitle,
		it: it.ad__magazine__generic_subtitle,
		nl: nl.ad__magazine__generic_subtitle,
		pt: pt.ad__magazine__generic_subtitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_title = (params = {}, options = {}) => {
	return {
		de: de.ad__magazine__generic_title,
		en: en.ad__magazine__generic_title,
		es: es.ad__magazine__generic_title,
		fr: fr.ad__magazine__generic_title,
		it: it.ad__magazine__generic_title,
		nl: nl.ad__magazine__generic_title,
		pt: pt.ad__magazine__generic_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__second_line = (params = {}, options = {}) => {
	return {
		de: de.ad__magazine__second_line,
		en: en.ad__magazine__second_line,
		es: es.ad__magazine__second_line,
		fr: fr.ad__magazine__second_line,
		it: it.ad__magazine__second_line,
		nl: nl.ad__magazine__second_line,
		pt: pt.ad__magazine__second_line
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__detail = (params = {}, options = {}) => {
	return {
		de: de.address__summary__error__detail,
		en: en.address__summary__error__detail,
		es: es.address__summary__error__detail,
		fr: fr.address__summary__error__detail,
		it: it.address__summary__error__detail,
		nl: nl.address__summary__error__detail,
		pt: pt.address__summary__error__detail
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__title = (params = {}, options = {}) => {
	return {
		de: de.address__summary__error__title,
		en: en.address__summary__error__title,
		es: es.address__summary__error__title,
		fr: fr.address__summary__error__title,
		it: it.address__summary__error__title,
		nl: nl.address__summary__error__title,
		pt: pt.address__summary__error__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alert_itinerary__closed_roads__cta = (params = {}, options = {}) => {
	return {
		de: de.alert_itinerary__closed_roads__cta,
		en: en.alert_itinerary__closed_roads__cta,
		es: es.alert_itinerary__closed_roads__cta,
		fr: fr.alert_itinerary__closed_roads__cta,
		it: it.alert_itinerary__closed_roads__cta,
		nl: nl.alert_itinerary__closed_roads__cta,
		pt: pt.alert_itinerary__closed_roads__cta
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__close_button__label = (params = {}, options = {}) => {
	return {
		de: de.alerts_traffic_panel__close_button__label,
		en: en.alerts_traffic_panel__close_button__label,
		es: es.alerts_traffic_panel__close_button__label,
		fr: fr.alerts_traffic_panel__close_button__label,
		it: it.alerts_traffic_panel__close_button__label,
		nl: nl.alerts_traffic_panel__close_button__label,
		pt: pt.alerts_traffic_panel__close_button__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__no_events__label = (params = {}, options = {}) => {
	return {
		de: de.alerts_traffic_panel__no_events__label,
		en: en.alerts_traffic_panel__no_events__label,
		es: es.alerts_traffic_panel__no_events__label,
		fr: fr.alerts_traffic_panel__no_events__label,
		it: it.alerts_traffic_panel__no_events__label,
		nl: nl.alerts_traffic_panel__no_events__label,
		pt: pt.alerts_traffic_panel__no_events__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__select_location__label = (params = {}, options = {}) => {
	return {
		de: de.alerts_traffic_panel__select_location__label,
		en: en.alerts_traffic_panel__select_location__label,
		es: es.alerts_traffic_panel__select_location__label,
		fr: fr.alerts_traffic_panel__select_location__label,
		it: it.alerts_traffic_panel__select_location__label,
		nl: nl.alerts_traffic_panel__select_location__label,
		pt: pt.alerts_traffic_panel__select_location__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__add__itinerary = (params = {}, options = {}) => {
	return {
		de: de.bookmark__add__itinerary,
		en: en.bookmark__add__itinerary,
		es: es.bookmark__add__itinerary,
		fr: fr.bookmark__add__itinerary,
		it: it.bookmark__add__itinerary,
		nl: nl.bookmark__add__itinerary,
		pt: pt.bookmark__add__itinerary
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_car = (params = {}, options = {}) => {
	return {
		de: de.bookmark__badge_car,
		en: en.bookmark__badge_car,
		es: es.bookmark__badge_car,
		fr: fr.bookmark__badge_car,
		it: it.bookmark__badge_car,
		nl: nl.bookmark__badge_car,
		pt: pt.bookmark__badge_car
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_caravan = (params = {}, options = {}) => {
	return {
		de: de.bookmark__badge_caravan,
		en: en.bookmark__badge_caravan,
		es: es.bookmark__badge_caravan,
		fr: fr.bookmark__badge_caravan,
		it: it.bookmark__badge_caravan,
		nl: nl.bookmark__badge_caravan,
		pt: pt.bookmark__badge_caravan
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_electricCar = (params = {}, options = {}) => {
	return {
		de: de.bookmark__badge_electricCar,
		en: en.bookmark__badge_electricCar,
		es: es.bookmark__badge_electricCar,
		fr: fr.bookmark__badge_electricCar,
		it: it.bookmark__badge_electricCar,
		nl: nl.bookmark__badge_electricCar,
		pt: pt.bookmark__badge_electricCar
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_motorcycle = (params = {}, options = {}) => {
	return {
		de: de.bookmark__badge_motorcycle,
		en: en.bookmark__badge_motorcycle,
		es: es.bookmark__badge_motorcycle,
		fr: fr.bookmark__badge_motorcycle,
		it: it.bookmark__badge_motorcycle,
		nl: nl.bookmark__badge_motorcycle,
		pt: pt.bookmark__badge_motorcycle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__delete_favorite_ariaLabel = (params = {}, options = {}) => {
	return {
		de: de.bookmark__delete_favorite_ariaLabel,
		en: en.bookmark__delete_favorite_ariaLabel,
		es: es.bookmark__delete_favorite_ariaLabel,
		fr: fr.bookmark__delete_favorite_ariaLabel,
		it: it.bookmark__delete_favorite_ariaLabel,
		nl: nl.bookmark__delete_favorite_ariaLabel,
		pt: pt.bookmark__delete_favorite_ariaLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite__routes = (params = {}, options = {}) => {
	return {
		de: de.bookmark__favorite__routes,
		en: en.bookmark__favorite__routes,
		es: es.bookmark__favorite__routes,
		fr: fr.bookmark__favorite__routes,
		it: it.bookmark__favorite__routes,
		nl: nl.bookmark__favorite__routes,
		pt: pt.bookmark__favorite__routes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached = (params = {}, options = {}) => {
	return {
		de: de.bookmark__favorite_limit_reached,
		en: en.bookmark__favorite_limit_reached,
		es: es.bookmark__favorite_limit_reached,
		fr: fr.bookmark__favorite_limit_reached,
		it: it.bookmark__favorite_limit_reached,
		nl: nl.bookmark__favorite_limit_reached,
		pt: pt.bookmark__favorite_limit_reached
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached__cta = (params = {}, options = {}) => {
	return {
		de: de.bookmark__favorite_limit_reached__cta,
		en: en.bookmark__favorite_limit_reached__cta,
		es: es.bookmark__favorite_limit_reached__cta,
		fr: fr.bookmark__favorite_limit_reached__cta,
		it: it.bookmark__favorite_limit_reached__cta,
		nl: nl.bookmark__favorite_limit_reached__cta,
		pt: pt.bookmark__favorite_limit_reached__cta
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__find_favorites_routes = (params = {}, options = {}) => {
	return {
		de: de.bookmark__find_favorites_routes,
		en: en.bookmark__find_favorites_routes,
		es: es.bookmark__find_favorites_routes,
		fr: fr.bookmark__find_favorites_routes,
		it: it.bookmark__find_favorites_routes,
		nl: nl.bookmark__find_favorites_routes,
		pt: pt.bookmark__find_favorites_routes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_deleted__success = (params = {}, options = {}) => {
	return {
		de: de.bookmark__iti_deleted__success,
		en: en.bookmark__iti_deleted__success,
		es: es.bookmark__iti_deleted__success,
		fr: fr.bookmark__iti_deleted__success,
		it: it.bookmark__iti_deleted__success,
		nl: nl.bookmark__iti_deleted__success,
		pt: pt.bookmark__iti_deleted__success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error = (params = {}, options = {}) => {
	return {
		de: de.bookmark__iti_save_error,
		en: en.bookmark__iti_save_error,
		es: es.bookmark__iti_save_error,
		fr: fr.bookmark__iti_save_error,
		it: it.bookmark__iti_save_error,
		nl: nl.bookmark__iti_save_error,
		pt: pt.bookmark__iti_save_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error__cta = (params = {}, options = {}) => {
	return {
		de: de.bookmark__iti_save_error__cta,
		en: en.bookmark__iti_save_error__cta,
		es: es.bookmark__iti_save_error__cta,
		fr: fr.bookmark__iti_save_error__cta,
		it: it.bookmark__iti_save_error__cta,
		nl: nl.bookmark__iti_save_error__cta,
		pt: pt.bookmark__iti_save_error__cta
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary__saved = (params = {}, options = {}) => {
	return {
		de: de.bookmark__itinerary__saved,
		en: en.bookmark__itinerary__saved,
		es: es.bookmark__itinerary__saved,
		fr: fr.bookmark__itinerary__saved,
		it: it.bookmark__itinerary__saved,
		nl: nl.bookmark__itinerary__saved,
		pt: pt.bookmark__itinerary__saved
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary_saved = (params = {}, options = {}) => {
	return {
		de: de.bookmark__itinerary_saved,
		en: en.bookmark__itinerary_saved,
		es: es.bookmark__itinerary_saved,
		fr: fr.bookmark__itinerary_saved,
		it: it.bookmark__itinerary_saved,
		nl: nl.bookmark__itinerary_saved,
		pt: pt.bookmark__itinerary_saved
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__no_saved_itineraries = (params = {}, options = {}) => {
	return {
		de: de.bookmark__no_saved_itineraries,
		en: en.bookmark__no_saved_itineraries,
		es: es.bookmark__no_saved_itineraries,
		fr: fr.bookmark__no_saved_itineraries,
		it: it.bookmark__no_saved_itineraries,
		nl: nl.bookmark__no_saved_itineraries,
		pt: pt.bookmark__no_saved_itineraries
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__save_favorite_route = (params = {}, options = {}) => {
	return {
		de: de.bookmark__save_favorite_route,
		en: en.bookmark__save_favorite_route,
		es: es.bookmark__save_favorite_route,
		fr: fr.bookmark__save_favorite_route,
		it: it.bookmark__save_favorite_route,
		nl: nl.bookmark__save_favorite_route,
		pt: pt.bookmark__save_favorite_route
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__see = (params = {}, options = {}) => {
	return {
		de: de.bookmark__see,
		en: en.bookmark__see,
		es: es.bookmark__see,
		fr: fr.bookmark__see,
		it: it.bookmark__see,
		nl: nl.bookmark__see,
		pt: pt.bookmark__see
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__see_favorite_route = (params = {}, options = {}) => {
	return {
		de: de.bookmark__see_favorite_route,
		en: en.bookmark__see_favorite_route,
		es: es.bookmark__see_favorite_route,
		fr: fr.bookmark__see_favorite_route,
		it: it.bookmark__see_favorite_route,
		nl: nl.bookmark__see_favorite_route,
		pt: pt.bookmark__see_favorite_route
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_actions = (params = {}, options = {}) => {
	return {
		de: de.bookmark__table_head_actions,
		en: en.bookmark__table_head_actions,
		es: es.bookmark__table_head_actions,
		fr: fr.bookmark__table_head_actions,
		it: it.bookmark__table_head_actions,
		nl: nl.bookmark__table_head_actions,
		pt: pt.bookmark__table_head_actions
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_iti_details = (params = {}, options = {}) => {
	return {
		de: de.bookmark__table_head_iti_details,
		en: en.bookmark__table_head_iti_details,
		es: es.bookmark__table_head_iti_details,
		fr: fr.bookmark__table_head_iti_details,
		it: it.bookmark__table_head_iti_details,
		nl: nl.bookmark__table_head_iti_details,
		pt: pt.bookmark__table_head_iti_details
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__via = (params = {}, options = {}) => {
	return {
		de: de.bookmark__via,
		en: en.bookmark__via,
		es: es.bookmark__via,
		fr: fr.bookmark__via,
		it: it.bookmark__via,
		nl: nl.bookmark__via,
		pt: pt.bookmark__via
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__placeholder = (params = {}, options = {}) => {
	return {
		de: de.calendar__arrival__placeholder,
		en: en.calendar__arrival__placeholder,
		es: es.calendar__arrival__placeholder,
		fr: fr.calendar__arrival__placeholder,
		it: it.calendar__arrival__placeholder,
		nl: nl.calendar__arrival__placeholder,
		pt: pt.calendar__arrival__placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__title = (params = {}, options = {}) => {
	return {
		de: de.calendar__arrival__title,
		en: en.calendar__arrival__title,
		es: es.calendar__arrival__title,
		fr: fr.calendar__arrival__title,
		it: it.calendar__arrival__title,
		nl: nl.calendar__arrival__title,
		pt: pt.calendar__arrival__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__cancel = (params = {}, options = {}) => {
	return {
		de: de.calendar__cancel,
		en: en.calendar__cancel,
		es: es.calendar__cancel,
		fr: fr.calendar__cancel,
		it: it.calendar__cancel,
		nl: nl.calendar__cancel,
		pt: pt.calendar__cancel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__validate = (params = {}, options = {}) => {
	return {
		de: de.calendar__validate,
		en: en.calendar__validate,
		es: es.calendar__validate,
		fr: fr.calendar__validate,
		it: it.calendar__validate,
		nl: nl.calendar__validate,
		pt: pt.calendar__validate
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__arrival_placeholder = (params = {}, options = {}) => {
	return {
		de: de.date_range_picker__arrival_placeholder,
		en: en.date_range_picker__arrival_placeholder,
		es: es.date_range_picker__arrival_placeholder,
		fr: fr.date_range_picker__arrival_placeholder,
		it: it.date_range_picker__arrival_placeholder,
		nl: nl.date_range_picker__arrival_placeholder,
		pt: pt.date_range_picker__arrival_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__close_aria_label = (params = {}, options = {}) => {
	return {
		de: de.date_range_picker__close_aria_label,
		en: en.date_range_picker__close_aria_label,
		es: es.date_range_picker__close_aria_label,
		fr: fr.date_range_picker__close_aria_label,
		it: it.date_range_picker__close_aria_label,
		nl: nl.date_range_picker__close_aria_label,
		pt: pt.date_range_picker__close_aria_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__departure_placeholder = (params = {}, options = {}) => {
	return {
		de: de.date_range_picker__departure_placeholder,
		en: en.date_range_picker__departure_placeholder,
		es: es.date_range_picker__departure_placeholder,
		fr: fr.date_range_picker__departure_placeholder,
		it: it.date_range_picker__departure_placeholder,
		nl: nl.date_range_picker__departure_placeholder,
		pt: pt.date_range_picker__departure_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__one = (params = {}, options = {}) => {
	return {
		de: de.date_range_picker__night_count_placeholder__one,
		en: en.date_range_picker__night_count_placeholder__one,
		es: es.date_range_picker__night_count_placeholder__one,
		fr: fr.date_range_picker__night_count_placeholder__one,
		it: it.date_range_picker__night_count_placeholder__one,
		nl: nl.date_range_picker__night_count_placeholder__one,
		pt: pt.date_range_picker__night_count_placeholder__one
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__other = (params = {}, options = {}) => {
	return {
		de: de.date_range_picker__night_count_placeholder__other,
		en: en.date_range_picker__night_count_placeholder__other,
		es: es.date_range_picker__night_count_placeholder__other,
		fr: fr.date_range_picker__night_count_placeholder__other,
		it: it.date_range_picker__night_count_placeholder__other,
		nl: nl.date_range_picker__night_count_placeholder__other,
		pt: pt.date_range_picker__night_count_placeholder__other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__trigger_aria_label = (params = {}, options = {}) => {
	return {
		de: de.date_range_picker__trigger_aria_label,
		en: en.date_range_picker__trigger_aria_label,
		es: es.date_range_picker__trigger_aria_label,
		fr: fr.date_range_picker__trigger_aria_label,
		it: it.date_range_picker__trigger_aria_label,
		nl: nl.date_range_picker__trigger_aria_label,
		pt: pt.date_range_picker__trigger_aria_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__back_home = (params = {}, options = {}) => {
	return {
		de: de.error__404__back_home,
		en: en.error__404__back_home,
		es: es.error__404__back_home,
		fr: fr.error__404__back_home,
		it: it.error__404__back_home,
		nl: nl.error__404__back_home,
		pt: pt.error__404__back_home
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__or = (params = {}, options = {}) => {
	return {
		de: de.error__404__or,
		en: en.error__404__or,
		es: es.error__404__or,
		fr: fr.error__404__or,
		it: it.error__404__or,
		nl: nl.error__404__or,
		pt: pt.error__404__or
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_end = (params = {}, options = {}) => {
	return {
		de: de.error__404__text_end,
		en: en.error__404__text_end,
		es: es.error__404__text_end,
		fr: fr.error__404__text_end,
		it: it.error__404__text_end,
		nl: nl.error__404__text_end,
		pt: pt.error__404__text_end
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_start = (params = {}, options = {}) => {
	return {
		de: de.error__404__text_start,
		en: en.error__404__text_start,
		es: es.error__404__text_start,
		fr: fr.error__404__text_start,
		it: it.error__404__text_start,
		nl: nl.error__404__text_start,
		pt: pt.error__404__text_start
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__title = (params = {}, options = {}) => {
	return {
		de: de.error__404__title,
		en: en.error__404__title,
		es: es.error__404__title,
		fr: fr.error__404__title,
		it: it.error__404__title,
		nl: nl.error__404__title,
		pt: pt.error__404__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_end = (params = {}, options = {}) => {
	return {
		de: de.error__500__text_end,
		en: en.error__500__text_end,
		es: es.error__500__text_end,
		fr: fr.error__500__text_end,
		it: it.error__500__text_end,
		nl: nl.error__500__text_end,
		pt: pt.error__500__text_end
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_start = (params = {}, options = {}) => {
	return {
		de: de.error__500__text_start,
		en: en.error__500__text_start,
		es: es.error__500__text_start,
		fr: fr.error__500__text_start,
		it: it.error__500__text_start,
		nl: nl.error__500__text_start,
		pt: pt.error__500__text_start
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__title = (params = {}, options = {}) => {
	return {
		de: de.error__500__title,
		en: en.error__500__title,
		es: es.error__500__title,
		fr: fr.error__500__title,
		it: it.error__500__title,
		nl: nl.error__500__title,
		pt: pt.error__500__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__contact_us = (params = {}, options = {}) => {
	return {
		de: de.error__contact_us,
		en: en.error__contact_us,
		es: es.error__contact_us,
		fr: fr.error__contact_us,
		it: it.error__contact_us,
		nl: nl.error__contact_us,
		pt: pt.error__contact_us
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__many = (params , options = {}) => {
	return {
		de: de.ev_spots__many,
		en: en.ev_spots__many,
		es: es.ev_spots__many,
		fr: fr.ev_spots__many,
		it: it.ev_spots__many,
		nl: nl.ev_spots__many,
		pt: pt.ev_spots__many
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__one = (params = {}, options = {}) => {
	return {
		de: de.ev_spots__one,
		en: en.ev_spots__one,
		es: es.ev_spots__one,
		fr: fr.ev_spots__one,
		it: it.ev_spots__one,
		nl: nl.ev_spots__one,
		pt: pt.ev_spots__one
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const favoriteItineraries__deleteError = (params = {}, options = {}) => {
	return {
		de: de.favoriteItineraries__deleteError,
		en: en.favoriteItineraries__deleteError,
		es: es.favoriteItineraries__deleteError,
		fr: fr.favoriteItineraries__deleteError,
		it: it.favoriteItineraries__deleteError,
		nl: nl.favoriteItineraries__deleteError,
		pt: pt.favoriteItineraries__deleteError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__faq_title = (params = {}, options = {}) => {
	return {
		de: de.footer__faq_title,
		en: en.footer__faq_title,
		es: es.footer__faq_title,
		fr: fr.footer__faq_title,
		it: it.footer__faq_title,
		nl: nl.footer__faq_title,
		pt: pt.footer__faq_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__magazine_button = (params = {}, options = {}) => {
	return {
		de: de.footer__magazine_button,
		en: en.footer__magazine_button,
		es: es.footer__magazine_button,
		fr: fr.footer__magazine_button,
		it: it.footer__magazine_button,
		nl: nl.footer__magazine_button,
		pt: pt.footer__magazine_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__newsletter_button = (params = {}, options = {}) => {
	return {
		de: de.footer__newsletter_button,
		en: en.footer__newsletter_button,
		es: es.footer__newsletter_button,
		fr: fr.footer__newsletter_button,
		it: it.footer__newsletter_button,
		nl: nl.footer__newsletter_button,
		pt: pt.footer__newsletter_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__B10 = (params = {}, options = {}) => {
	return {
		de: de.gas_station__fuel_label__B10,
		en: en.gas_station__fuel_label__B10,
		es: es.gas_station__fuel_label__B10,
		fr: fr.gas_station__fuel_label__B10,
		it: it.gas_station__fuel_label__B10,
		nl: nl.gas_station__fuel_label__B10,
		pt: pt.gas_station__fuel_label__B10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__B7 = (params = {}, options = {}) => {
	return {
		de: de.gas_station__fuel_label__B7,
		en: en.gas_station__fuel_label__B7,
		es: es.gas_station__fuel_label__B7,
		fr: fr.gas_station__fuel_label__B7,
		it: it.gas_station__fuel_label__B7,
		nl: nl.gas_station__fuel_label__B7,
		pt: pt.gas_station__fuel_label__B7
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__CNG = (params = {}, options = {}) => {
	return {
		de: de.gas_station__fuel_label__CNG,
		en: en.gas_station__fuel_label__CNG,
		es: es.gas_station__fuel_label__CNG,
		fr: fr.gas_station__fuel_label__CNG,
		it: it.gas_station__fuel_label__CNG,
		nl: nl.gas_station__fuel_label__CNG,
		pt: pt.gas_station__fuel_label__CNG
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E10 = (params = {}, options = {}) => {
	return {
		de: de.gas_station__fuel_label__E10,
		en: en.gas_station__fuel_label__E10,
		es: es.gas_station__fuel_label__E10,
		fr: fr.gas_station__fuel_label__E10,
		it: it.gas_station__fuel_label__E10,
		nl: nl.gas_station__fuel_label__E10,
		pt: pt.gas_station__fuel_label__E10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E5 = (params = {}, options = {}) => {
	return {
		de: de.gas_station__fuel_label__E5,
		en: en.gas_station__fuel_label__E5,
		es: es.gas_station__fuel_label__E5,
		fr: fr.gas_station__fuel_label__E5,
		it: it.gas_station__fuel_label__E5,
		nl: nl.gas_station__fuel_label__E5,
		pt: pt.gas_station__fuel_label__E5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E5_98 = (params = {}, options = {}) => {
	return {
		de: de.gas_station__fuel_label__E5_98,
		en: en.gas_station__fuel_label__E5_98,
		es: es.gas_station__fuel_label__E5_98,
		fr: fr.gas_station__fuel_label__E5_98,
		it: it.gas_station__fuel_label__E5_98,
		nl: nl.gas_station__fuel_label__E5_98,
		pt: pt.gas_station__fuel_label__E5_98
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E85 = (params = {}, options = {}) => {
	return {
		de: de.gas_station__fuel_label__E85,
		en: en.gas_station__fuel_label__E85,
		es: es.gas_station__fuel_label__E85,
		fr: fr.gas_station__fuel_label__E85,
		it: it.gas_station__fuel_label__E85,
		nl: nl.gas_station__fuel_label__E85,
		pt: pt.gas_station__fuel_label__E85
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__H2 = (params = {}, options = {}) => {
	return {
		de: de.gas_station__fuel_label__H2,
		en: en.gas_station__fuel_label__H2,
		es: es.gas_station__fuel_label__H2,
		fr: fr.gas_station__fuel_label__H2,
		it: it.gas_station__fuel_label__H2,
		nl: nl.gas_station__fuel_label__H2,
		pt: pt.gas_station__fuel_label__H2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__LPG = (params = {}, options = {}) => {
	return {
		de: de.gas_station__fuel_label__LPG,
		en: en.gas_station__fuel_label__LPG,
		es: es.gas_station__fuel_label__LPG,
		fr: fr.gas_station__fuel_label__LPG,
		it: it.gas_station__fuel_label__LPG,
		nl: nl.gas_station__fuel_label__LPG,
		pt: pt.gas_station__fuel_label__LPG
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const highways = (params = {}, options = {}) => {
	return {
		de: de.highways,
		en: en.highways,
		es: es.highways,
		fr: fr.highways,
		it: it.highways,
		nl: nl.highways,
		pt: pt.highways
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const input__clear = (params = {}, options = {}) => {
	return {
		de: de.input__clear,
		en: en.input__clear,
		es: es.input__clear,
		fr: fr.input__clear,
		it: it.input__clear,
		nl: nl.input__clear,
		pt: pt.input__clear
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__ad__loading = (params , options = {}) => {
	return {
		de: de.itinerary__ad__loading,
		en: en.itinerary__ad__loading,
		es: es.itinerary__ad__loading,
		fr: fr.itinerary__ad__loading,
		it: it.itinerary__ad__loading,
		nl: nl.itinerary__ad__loading,
		pt: pt.itinerary__ad__loading
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__add_step = (params = {}, options = {}) => {
	return {
		de: de.itinerary__add_step,
		en: en.itinerary__add_step,
		es: es.itinerary__add_step,
		fr: fr.itinerary__add_step,
		it: it.itinerary__add_step,
		nl: nl.itinerary__add_step,
		pt: pt.itinerary__add_step
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__compute = (params = {}, options = {}) => {
	return {
		de: de.itinerary__compute,
		en: en.itinerary__compute,
		es: es.itinerary__compute,
		fr: fr.itinerary__compute,
		it: it.itinerary__compute,
		nl: nl.itinerary__compute,
		pt: pt.itinerary__compute
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__current_location = (params = {}, options = {}) => {
	return {
		de: de.itinerary__current_location,
		en: en.itinerary__current_location,
		es: es.itinerary__current_location,
		fr: fr.itinerary__current_location,
		it: it.itinerary__current_location,
		nl: nl.itinerary__current_location,
		pt: pt.itinerary__current_location
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__edit = (params = {}, options = {}) => {
	return {
		de: de.itinerary__edit,
		en: en.itinerary__edit,
		es: es.itinerary__edit,
		fr: fr.itinerary__edit,
		it: it.itinerary__edit,
		nl: nl.itinerary__edit,
		pt: pt.itinerary__edit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__invert = (params = {}, options = {}) => {
	return {
		de: de.itinerary__invert,
		en: en.itinerary__invert,
		es: es.itinerary__invert,
		fr: fr.itinerary__invert,
		it: it.itinerary__invert,
		nl: nl.itinerary__invert,
		pt: pt.itinerary__invert
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__max_steps_reached = (params = {}, options = {}) => {
	return {
		de: de.itinerary__max_steps_reached,
		en: en.itinerary__max_steps_reached,
		es: es.itinerary__max_steps_reached,
		fr: fr.itinerary__max_steps_reached,
		it: it.itinerary__max_steps_reached,
		nl: nl.itinerary__max_steps_reached,
		pt: pt.itinerary__max_steps_reached
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__edit = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_badge__edit,
		en: en.itinerary__options__car_badge__edit,
		es: es.itinerary__options__car_badge__edit,
		fr: fr.itinerary__options__car_badge__edit,
		it: it.itinerary__options__car_badge__edit,
		nl: nl.itinerary__options__car_badge__edit,
		pt: pt.itinerary__options__car_badge__edit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__register = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_badge__register,
		en: en.itinerary__options__car_badge__register,
		es: es.itinerary__options__car_badge__register,
		fr: fr.itinerary__options__car_badge__register,
		it: it.itinerary__options__car_badge__register,
		nl: nl.itinerary__options__car_badge__register,
		pt: pt.itinerary__options__car_badge__register
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__user = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_badge__user,
		en: en.itinerary__options__car_badge__user,
		es: es.itinerary__options__car_badge__user,
		fr: fr.itinerary__options__car_badge__user,
		it: it.itinerary__options__car_badge__user,
		nl: nl.itinerary__options__car_badge__user,
		pt: pt.itinerary__options__car_badge__user
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__bifuel = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_energy__bifuel,
		en: en.itinerary__options__car_energy__bifuel,
		es: es.itinerary__options__car_energy__bifuel,
		fr: fr.itinerary__options__car_energy__bifuel,
		it: it.itinerary__options__car_energy__bifuel,
		nl: nl.itinerary__options__car_energy__bifuel,
		pt: pt.itinerary__options__car_energy__bifuel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__cng = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_energy__cng,
		en: en.itinerary__options__car_energy__cng,
		es: es.itinerary__options__car_energy__cng,
		fr: fr.itinerary__options__car_energy__cng,
		it: it.itinerary__options__car_energy__cng,
		nl: nl.itinerary__options__car_energy__cng,
		pt: pt.itinerary__options__car_energy__cng
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__diesel = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_energy__diesel,
		en: en.itinerary__options__car_energy__diesel,
		es: es.itinerary__options__car_energy__diesel,
		fr: fr.itinerary__options__car_energy__diesel,
		it: it.itinerary__options__car_energy__diesel,
		nl: nl.itinerary__options__car_energy__diesel,
		pt: pt.itinerary__options__car_energy__diesel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__electric = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_energy__electric,
		en: en.itinerary__options__car_energy__electric,
		es: es.itinerary__options__car_energy__electric,
		fr: fr.itinerary__options__car_energy__electric,
		it: it.itinerary__options__car_energy__electric,
		nl: nl.itinerary__options__car_energy__electric,
		pt: pt.itinerary__options__car_energy__electric
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__ethanol = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_energy__ethanol,
		en: en.itinerary__options__car_energy__ethanol,
		es: es.itinerary__options__car_energy__ethanol,
		fr: fr.itinerary__options__car_energy__ethanol,
		it: it.itinerary__options__car_energy__ethanol,
		nl: nl.itinerary__options__car_energy__ethanol,
		pt: pt.itinerary__options__car_energy__ethanol
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__gasoline = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_energy__gasoline,
		en: en.itinerary__options__car_energy__gasoline,
		es: es.itinerary__options__car_energy__gasoline,
		fr: fr.itinerary__options__car_energy__gasoline,
		it: it.itinerary__options__car_energy__gasoline,
		nl: nl.itinerary__options__car_energy__gasoline,
		pt: pt.itinerary__options__car_energy__gasoline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__hybrid = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_energy__hybrid,
		en: en.itinerary__options__car_energy__hybrid,
		es: es.itinerary__options__car_energy__hybrid,
		fr: fr.itinerary__options__car_energy__hybrid,
		it: it.itinerary__options__car_energy__hybrid,
		nl: nl.itinerary__options__car_energy__hybrid,
		pt: pt.itinerary__options__car_energy__hybrid
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__hydrogen = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_energy__hydrogen,
		en: en.itinerary__options__car_energy__hydrogen,
		es: es.itinerary__options__car_energy__hydrogen,
		fr: fr.itinerary__options__car_energy__hydrogen,
		it: it.itinerary__options__car_energy__hydrogen,
		nl: nl.itinerary__options__car_energy__hydrogen,
		pt: pt.itinerary__options__car_energy__hydrogen
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__lpg = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_energy__lpg,
		en: en.itinerary__options__car_energy__lpg,
		es: es.itinerary__options__car_energy__lpg,
		fr: fr.itinerary__options__car_energy__lpg,
		it: it.itinerary__options__car_energy__lpg,
		nl: nl.itinerary__options__car_energy__lpg,
		pt: pt.itinerary__options__car_energy__lpg
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__city = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_type__city,
		en: en.itinerary__options__car_type__city,
		es: es.itinerary__options__car_type__city,
		fr: fr.itinerary__options__car_type__city,
		it: it.itinerary__options__car_type__city,
		nl: nl.itinerary__options__car_type__city,
		pt: pt.itinerary__options__car_type__city
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__compact = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_type__compact,
		en: en.itinerary__options__car_type__compact,
		es: es.itinerary__options__car_type__compact,
		fr: fr.itinerary__options__car_type__compact,
		it: it.itinerary__options__car_type__compact,
		nl: nl.itinerary__options__car_type__compact,
		pt: pt.itinerary__options__car_type__compact
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__saloon = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_type__saloon,
		en: en.itinerary__options__car_type__saloon,
		es: es.itinerary__options__car_type__saloon,
		fr: fr.itinerary__options__car_type__saloon,
		it: it.itinerary__options__car_type__saloon,
		nl: nl.itinerary__options__car_type__saloon,
		pt: pt.itinerary__options__car_type__saloon
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__sports = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_type__sports,
		en: en.itinerary__options__car_type__sports,
		es: es.itinerary__options__car_type__sports,
		fr: fr.itinerary__options__car_type__sports,
		it: it.itinerary__options__car_type__sports,
		nl: nl.itinerary__options__car_type__sports,
		pt: pt.itinerary__options__car_type__sports
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__suv = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__car_type__suv,
		en: en.itinerary__options__car_type__suv,
		es: es.itinerary__options__car_type__suv,
		fr: fr.itinerary__options__car_type__suv,
		it: it.itinerary__options__car_type__suv,
		nl: nl.itinerary__options__car_type__suv,
		pt: pt.itinerary__options__car_type__suv
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__caravan_toggle = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__caravan_toggle,
		en: en.itinerary__options__caravan_toggle,
		es: es.itinerary__options__caravan_toggle,
		fr: fr.itinerary__options__caravan_toggle,
		it: it.itinerary__options__caravan_toggle,
		nl: nl.itinerary__options__caravan_toggle,
		pt: pt.itinerary__options__caravan_toggle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__caravan_toggle_helper_text = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__caravan_toggle_helper_text,
		en: en.itinerary__options__caravan_toggle_helper_text,
		es: es.itinerary__options__caravan_toggle_helper_text,
		fr: fr.itinerary__options__caravan_toggle_helper_text,
		it: it.itinerary__options__caravan_toggle_helper_text,
		nl: nl.itinerary__options__caravan_toggle_helper_text,
		pt: pt.itinerary__options__caravan_toggle_helper_text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__cars__error = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__cars__error,
		en: en.itinerary__options__cars__error,
		es: es.itinerary__options__cars__error,
		fr: fr.itinerary__options__cars__error,
		it: it.itinerary__options__cars__error,
		nl: nl.itinerary__options__cars__error,
		pt: pt.itinerary__options__cars__error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__cars__retry = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__cars__retry,
		en: en.itinerary__options__cars__retry,
		es: es.itinerary__options__cars__retry,
		fr: fr.itinerary__options__cars__retry,
		it: it.itinerary__options__cars__retry,
		nl: nl.itinerary__options__cars__retry,
		pt: pt.itinerary__options__cars__retry
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_border_crossing = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__constraints__no_border_crossing,
		en: en.itinerary__options__constraints__no_border_crossing,
		es: es.itinerary__options__constraints__no_border_crossing,
		fr: fr.itinerary__options__constraints__no_border_crossing,
		it: it.itinerary__options__constraints__no_border_crossing,
		nl: nl.itinerary__options__constraints__no_border_crossing,
		pt: pt.itinerary__options__constraints__no_border_crossing
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_ferry = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__constraints__no_ferry,
		en: en.itinerary__options__constraints__no_ferry,
		es: es.itinerary__options__constraints__no_ferry,
		fr: fr.itinerary__options__constraints__no_ferry,
		it: it.itinerary__options__constraints__no_ferry,
		nl: nl.itinerary__options__constraints__no_ferry,
		pt: pt.itinerary__options__constraints__no_ferry
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_low_emission_zone = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__constraints__no_low_emission_zone,
		en: en.itinerary__options__constraints__no_low_emission_zone,
		es: es.itinerary__options__constraints__no_low_emission_zone,
		fr: fr.itinerary__options__constraints__no_low_emission_zone,
		it: it.itinerary__options__constraints__no_low_emission_zone,
		nl: nl.itinerary__options__constraints__no_low_emission_zone,
		pt: pt.itinerary__options__constraints__no_low_emission_zone
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_motorway = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__constraints__no_motorway,
		en: en.itinerary__options__constraints__no_motorway,
		es: es.itinerary__options__constraints__no_motorway,
		fr: fr.itinerary__options__constraints__no_motorway,
		it: it.itinerary__options__constraints__no_motorway,
		nl: nl.itinerary__options__constraints__no_motorway,
		pt: pt.itinerary__options__constraints__no_motorway
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_toll = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__constraints__no_toll,
		en: en.itinerary__options__constraints__no_toll,
		es: es.itinerary__options__constraints__no_toll,
		fr: fr.itinerary__options__constraints__no_toll,
		it: it.itinerary__options__constraints__no_toll,
		nl: nl.itinerary__options__constraints__no_toll,
		pt: pt.itinerary__options__constraints__no_toll
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_vignette = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__constraints__no_vignette,
		en: en.itinerary__options__constraints__no_vignette,
		es: es.itinerary__options__constraints__no_vignette,
		fr: fr.itinerary__options__constraints__no_vignette,
		it: it.itinerary__options__constraints__no_vignette,
		nl: nl.itinerary__options__constraints__no_vignette,
		pt: pt.itinerary__options__constraints__no_vignette
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__none = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__constraints__none,
		en: en.itinerary__options__constraints__none,
		es: es.itinerary__options__constraints__none,
		fr: fr.itinerary__options__constraints__none,
		it: it.itinerary__options__constraints__none,
		nl: nl.itinerary__options__constraints__none,
		pt: pt.itinerary__options__constraints__none
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency,
		en: en.itinerary__options__currency,
		es: es.itinerary__options__currency,
		fr: fr.itinerary__options__currency,
		it: it.itinerary__options__currency,
		nl: nl.itinerary__options__currency,
		pt: pt.itinerary__options__currency
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__chf = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__chf,
		en: en.itinerary__options__currency__chf,
		es: es.itinerary__options__currency__chf,
		fr: fr.itinerary__options__currency__chf,
		it: it.itinerary__options__currency__chf,
		nl: nl.itinerary__options__currency__chf,
		pt: pt.itinerary__options__currency__chf
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__czk = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__czk,
		en: en.itinerary__options__currency__czk,
		es: es.itinerary__options__currency__czk,
		fr: fr.itinerary__options__currency__czk,
		it: it.itinerary__options__currency__czk,
		nl: nl.itinerary__options__currency__czk,
		pt: pt.itinerary__options__currency__czk
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__dkk = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__dkk,
		en: en.itinerary__options__currency__dkk,
		es: es.itinerary__options__currency__dkk,
		fr: fr.itinerary__options__currency__dkk,
		it: it.itinerary__options__currency__dkk,
		nl: nl.itinerary__options__currency__dkk,
		pt: pt.itinerary__options__currency__dkk
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__eur = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__eur,
		en: en.itinerary__options__currency__eur,
		es: es.itinerary__options__currency__eur,
		fr: fr.itinerary__options__currency__eur,
		it: it.itinerary__options__currency__eur,
		nl: nl.itinerary__options__currency__eur,
		pt: pt.itinerary__options__currency__eur
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__gbp = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__gbp,
		en: en.itinerary__options__currency__gbp,
		es: es.itinerary__options__currency__gbp,
		fr: fr.itinerary__options__currency__gbp,
		it: it.itinerary__options__currency__gbp,
		nl: nl.itinerary__options__currency__gbp,
		pt: pt.itinerary__options__currency__gbp
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__hrk = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__hrk,
		en: en.itinerary__options__currency__hrk,
		es: es.itinerary__options__currency__hrk,
		fr: fr.itinerary__options__currency__hrk,
		it: it.itinerary__options__currency__hrk,
		nl: nl.itinerary__options__currency__hrk,
		pt: pt.itinerary__options__currency__hrk
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__huf = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__huf,
		en: en.itinerary__options__currency__huf,
		es: es.itinerary__options__currency__huf,
		fr: fr.itinerary__options__currency__huf,
		it: it.itinerary__options__currency__huf,
		nl: nl.itinerary__options__currency__huf,
		pt: pt.itinerary__options__currency__huf
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__jpy = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__jpy,
		en: en.itinerary__options__currency__jpy,
		es: es.itinerary__options__currency__jpy,
		fr: fr.itinerary__options__currency__jpy,
		it: it.itinerary__options__currency__jpy,
		nl: nl.itinerary__options__currency__jpy,
		pt: pt.itinerary__options__currency__jpy
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__nok = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__nok,
		en: en.itinerary__options__currency__nok,
		es: es.itinerary__options__currency__nok,
		fr: fr.itinerary__options__currency__nok,
		it: it.itinerary__options__currency__nok,
		nl: nl.itinerary__options__currency__nok,
		pt: pt.itinerary__options__currency__nok
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__pln = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__pln,
		en: en.itinerary__options__currency__pln,
		es: es.itinerary__options__currency__pln,
		fr: fr.itinerary__options__currency__pln,
		it: it.itinerary__options__currency__pln,
		nl: nl.itinerary__options__currency__pln,
		pt: pt.itinerary__options__currency__pln
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__sek = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__sek,
		en: en.itinerary__options__currency__sek,
		es: es.itinerary__options__currency__sek,
		fr: fr.itinerary__options__currency__sek,
		it: it.itinerary__options__currency__sek,
		nl: nl.itinerary__options__currency__sek,
		pt: pt.itinerary__options__currency__sek
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__uah = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__uah,
		en: en.itinerary__options__currency__uah,
		es: es.itinerary__options__currency__uah,
		fr: fr.itinerary__options__currency__uah,
		it: it.itinerary__options__currency__uah,
		nl: nl.itinerary__options__currency__uah,
		pt: pt.itinerary__options__currency__uah
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__usd = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__currency__usd,
		en: en.itinerary__options__currency__usd,
		es: es.itinerary__options__currency__usd,
		fr: fr.itinerary__options__currency__usd,
		it: it.itinerary__options__currency__usd,
		nl: nl.itinerary__options__currency__usd,
		pt: pt.itinerary__options__currency__usd
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__distance_unit = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__distance_unit,
		en: en.itinerary__options__distance_unit,
		es: es.itinerary__options__distance_unit,
		fr: fr.itinerary__options__distance_unit,
		it: it.itinerary__options__distance_unit,
		nl: nl.itinerary__options__distance_unit,
		pt: pt.itinerary__options__distance_unit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__ev_toggle = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__ev_toggle,
		en: en.itinerary__options__ev_toggle,
		es: es.itinerary__options__ev_toggle,
		fr: fr.itinerary__options__ev_toggle,
		it: it.itinerary__options__ev_toggle,
		nl: nl.itinerary__options__ev_toggle,
		pt: pt.itinerary__options__ev_toggle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__fuel__price = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__fuel__price,
		en: en.itinerary__options__fuel__price,
		es: es.itinerary__options__fuel__price,
		fr: fr.itinerary__options__fuel__price,
		it: it.itinerary__options__fuel__price,
		nl: nl.itinerary__options__fuel__price,
		pt: pt.itinerary__options__fuel__price
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__kwh__price = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__kwh__price,
		en: en.itinerary__options__kwh__price,
		es: es.itinerary__options__kwh__price,
		fr: fr.itinerary__options__kwh__price,
		it: it.itinerary__options__kwh__price,
		nl: nl.itinerary__options__kwh__price,
		pt: pt.itinerary__options__kwh__price
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__bike = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__modes__bike,
		en: en.itinerary__options__modes__bike,
		es: es.itinerary__options__modes__bike,
		fr: fr.itinerary__options__modes__bike,
		it: it.itinerary__options__modes__bike,
		nl: nl.itinerary__options__modes__bike,
		pt: pt.itinerary__options__modes__bike
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__modes__car,
		en: en.itinerary__options__modes__car,
		es: es.itinerary__options__modes__car,
		fr: fr.itinerary__options__modes__car,
		it: it.itinerary__options__modes__car,
		nl: nl.itinerary__options__modes__car,
		pt: pt.itinerary__options__modes__car
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__modes__car_ev_limit,
		en: en.itinerary__options__modes__car_ev_limit,
		es: es.itinerary__options__modes__car_ev_limit,
		fr: fr.itinerary__options__modes__car_ev_limit,
		it: it.itinerary__options__modes__car_ev_limit,
		nl: nl.itinerary__options__modes__car_ev_limit,
		pt: pt.itinerary__options__modes__car_ev_limit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit_warning_message = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__modes__car_ev_limit_warning_message,
		en: en.itinerary__options__modes__car_ev_limit_warning_message,
		es: es.itinerary__options__modes__car_ev_limit_warning_message,
		fr: fr.itinerary__options__modes__car_ev_limit_warning_message,
		it: it.itinerary__options__modes__car_ev_limit_warning_message,
		nl: nl.itinerary__options__modes__car_ev_limit_warning_message,
		pt: pt.itinerary__options__modes__car_ev_limit_warning_message
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__motorcycle = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__modes__motorcycle,
		en: en.itinerary__options__modes__motorcycle,
		es: es.itinerary__options__modes__motorcycle,
		fr: fr.itinerary__options__modes__motorcycle,
		it: it.itinerary__options__modes__motorcycle,
		nl: nl.itinerary__options__modes__motorcycle,
		pt: pt.itinerary__options__modes__motorcycle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__walk = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__modes__walk,
		en: en.itinerary__options__modes__walk,
		es: es.itinerary__options__modes__walk,
		fr: fr.itinerary__options__modes__walk,
		it: it.itinerary__options__modes__walk,
		nl: nl.itinerary__options__modes__walk,
		pt: pt.itinerary__options__modes__walk
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__title = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__title,
		en: en.itinerary__options__title,
		es: es.itinerary__options__title,
		fr: fr.itinerary__options__title,
		it: it.itinerary__options__title,
		nl: nl.itinerary__options__title,
		pt: pt.itinerary__options__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__traffic_toggle = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__traffic_toggle,
		en: en.itinerary__options__traffic_toggle,
		es: es.itinerary__options__traffic_toggle,
		fr: fr.itinerary__options__traffic_toggle,
		it: it.itinerary__options__traffic_toggle,
		nl: nl.itinerary__options__traffic_toggle,
		pt: pt.itinerary__options__traffic_toggle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__travel_mode = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__travel_mode,
		en: en.itinerary__options__travel_mode,
		es: es.itinerary__options__travel_mode,
		fr: fr.itinerary__options__travel_mode,
		it: it.itinerary__options__travel_mode,
		nl: nl.itinerary__options__travel_mode,
		pt: pt.itinerary__options__travel_mode
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__trip_constraint = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__trip_constraint,
		en: en.itinerary__options__trip_constraint,
		es: es.itinerary__options__trip_constraint,
		fr: fr.itinerary__options__trip_constraint,
		it: it.itinerary__options__trip_constraint,
		nl: nl.itinerary__options__trip_constraint,
		pt: pt.itinerary__options__trip_constraint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__units__imperial = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__units__imperial,
		en: en.itinerary__options__units__imperial,
		es: es.itinerary__options__units__imperial,
		fr: fr.itinerary__options__units__imperial,
		it: it.itinerary__options__units__imperial,
		nl: nl.itinerary__options__units__imperial,
		pt: pt.itinerary__options__units__imperial
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__units__metric = (params = {}, options = {}) => {
	return {
		de: de.itinerary__options__units__metric,
		en: en.itinerary__options__units__metric,
		es: es.itinerary__options__units__metric,
		fr: fr.itinerary__options__units__metric,
		it: it.itinerary__options__units__metric,
		nl: nl.itinerary__options__units__metric,
		pt: pt.itinerary__options__units__metric
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__recompute = (params = {}, options = {}) => {
	return {
		de: de.itinerary__recompute,
		en: en.itinerary__recompute,
		es: es.itinerary__recompute,
		fr: fr.itinerary__recompute,
		it: it.itinerary__recompute,
		nl: nl.itinerary__recompute,
		pt: pt.itinerary__recompute
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__summary__traffic_avoided_badge = (params = {}, options = {}) => {
	return {
		de: de.itinerary__summary__traffic_avoided_badge,
		en: en.itinerary__summary__traffic_avoided_badge,
		es: es.itinerary__summary__traffic_avoided_badge,
		fr: fr.itinerary__summary__traffic_avoided_badge,
		it: it.itinerary__summary__traffic_avoided_badge,
		nl: nl.itinerary__summary__traffic_avoided_badge,
		pt: pt.itinerary__summary__traffic_avoided_badge
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const kleber__restStop__description = (params = {}, options = {}) => {
	return {
		de: de.kleber__restStop__description,
		en: en.kleber__restStop__description,
		es: es.kleber__restStop__description,
		fr: fr.kleber__restStop__description,
		it: it.kleber__restStop__description,
		nl: nl.kleber__restStop__description,
		pt: pt.kleber__restStop__description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const kleber__village__description = (params = {}, options = {}) => {
	return {
		de: de.kleber__village__description,
		en: en.kleber__village__description,
		es: es.kleber__village__description,
		fr: fr.kleber__village__description,
		it: it.kleber__village__description,
		nl: nl.kleber__village__description,
		pt: pt.kleber__village__description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_add_car = (params = {}, options = {}) => {
	return {
		de: de.launchpad__account_modal_add_car,
		en: en.launchpad__account_modal_add_car,
		es: es.launchpad__account_modal_add_car,
		fr: fr.launchpad__account_modal_add_car,
		it: it.launchpad__account_modal_add_car,
		nl: nl.launchpad__account_modal_add_car,
		pt: pt.launchpad__account_modal_add_car
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_create = (params = {}, options = {}) => {
	return {
		de: de.launchpad__account_modal_create,
		en: en.launchpad__account_modal_create,
		es: es.launchpad__account_modal_create,
		fr: fr.launchpad__account_modal_create,
		it: it.launchpad__account_modal_create,
		nl: nl.launchpad__account_modal_create,
		pt: pt.launchpad__account_modal_create
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_create_account = (params = {}, options = {}) => {
	return {
		de: de.launchpad__account_modal_create_account,
		en: en.launchpad__account_modal_create_account,
		es: es.launchpad__account_modal_create_account,
		fr: fr.launchpad__account_modal_create_account,
		it: it.launchpad__account_modal_create_account,
		nl: nl.launchpad__account_modal_create_account,
		pt: pt.launchpad__account_modal_create_account
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_ideas = (params = {}, options = {}) => {
	return {
		de: de.launchpad__account_modal_ideas,
		en: en.launchpad__account_modal_ideas,
		es: es.launchpad__account_modal_ideas,
		fr: fr.launchpad__account_modal_ideas,
		it: it.launchpad__account_modal_ideas,
		nl: nl.launchpad__account_modal_ideas,
		pt: pt.launchpad__account_modal_ideas
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_more = (params = {}, options = {}) => {
	return {
		de: de.launchpad__account_modal_more,
		en: en.launchpad__account_modal_more,
		es: es.launchpad__account_modal_more,
		fr: fr.launchpad__account_modal_more,
		it: it.launchpad__account_modal_more,
		nl: nl.launchpad__account_modal_more,
		pt: pt.launchpad__account_modal_more
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_newsletter = (params = {}, options = {}) => {
	return {
		de: de.launchpad__account_modal_newsletter,
		en: en.launchpad__account_modal_newsletter,
		es: es.launchpad__account_modal_newsletter,
		fr: fr.launchpad__account_modal_newsletter,
		it: it.launchpad__account_modal_newsletter,
		nl: nl.launchpad__account_modal_newsletter,
		pt: pt.launchpad__account_modal_newsletter
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_save_pref = (params = {}, options = {}) => {
	return {
		de: de.launchpad__account_modal_save_pref,
		en: en.launchpad__account_modal_save_pref,
		es: es.launchpad__account_modal_save_pref,
		fr: fr.launchpad__account_modal_save_pref,
		it: it.launchpad__account_modal_save_pref,
		nl: nl.launchpad__account_modal_save_pref,
		pt: pt.launchpad__account_modal_save_pref
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_signin = (params = {}, options = {}) => {
	return {
		de: de.launchpad__account_modal_signin,
		en: en.launchpad__account_modal_signin,
		es: es.launchpad__account_modal_signin,
		fr: fr.launchpad__account_modal_signin,
		it: it.launchpad__account_modal_signin,
		nl: nl.launchpad__account_modal_signin,
		pt: pt.launchpad__account_modal_signin
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_cta_label = (params = {}, options = {}) => {
	return {
		de: de.launchpad__cost_cta_label,
		en: en.launchpad__cost_cta_label,
		es: es.launchpad__cost_cta_label,
		fr: fr.launchpad__cost_cta_label,
		it: it.launchpad__cost_cta_label,
		nl: nl.launchpad__cost_cta_label,
		pt: pt.launchpad__cost_cta_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_notification = (params = {}, options = {}) => {
	return {
		de: de.launchpad__cost_notification,
		en: en.launchpad__cost_notification,
		es: es.launchpad__cost_notification,
		fr: fr.launchpad__cost_notification,
		it: it.launchpad__cost_notification,
		nl: nl.launchpad__cost_notification,
		pt: pt.launchpad__cost_notification
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_title = (params = {}, options = {}) => {
	return {
		de: de.launchpad__cost_title,
		en: en.launchpad__cost_title,
		es: es.launchpad__cost_title,
		fr: fr.launchpad__cost_title,
		it: it.launchpad__cost_title,
		nl: nl.launchpad__cost_title,
		pt: pt.launchpad__cost_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__headline_title = (params = {}, options = {}) => {
	return {
		de: de.launchpad__headline_title,
		en: en.launchpad__headline_title,
		es: es.launchpad__headline_title,
		fr: fr.launchpad__headline_title,
		it: it.launchpad__headline_title,
		nl: nl.launchpad__headline_title,
		pt: pt.launchpad__headline_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__magazine_cta_label = (params = {}, options = {}) => {
	return {
		de: de.launchpad__magazine_cta_label,
		en: en.launchpad__magazine_cta_label,
		es: es.launchpad__magazine_cta_label,
		fr: fr.launchpad__magazine_cta_label,
		it: it.launchpad__magazine_cta_label,
		nl: nl.launchpad__magazine_cta_label,
		pt: pt.launchpad__magazine_cta_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__magazine_title = (params = {}, options = {}) => {
	return {
		de: de.launchpad__magazine_title,
		en: en.launchpad__magazine_title,
		es: es.launchpad__magazine_title,
		fr: fr.launchpad__magazine_title,
		it: it.launchpad__magazine_title,
		nl: nl.launchpad__magazine_title,
		pt: pt.launchpad__magazine_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__pois_hrt = (params = {}, options = {}) => {
	return {
		de: de.launchpad__pois_hrt,
		en: en.launchpad__pois_hrt,
		es: es.launchpad__pois_hrt,
		fr: fr.launchpad__pois_hrt,
		it: it.launchpad__pois_hrt,
		nl: nl.launchpad__pois_hrt,
		pt: pt.launchpad__pois_hrt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__selection_cta_label = (params = {}, options = {}) => {
	return {
		de: de.launchpad__selection_cta_label,
		en: en.launchpad__selection_cta_label,
		es: es.launchpad__selection_cta_label,
		fr: fr.launchpad__selection_cta_label,
		it: it.launchpad__selection_cta_label,
		nl: nl.launchpad__selection_cta_label,
		pt: pt.launchpad__selection_cta_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__selection_title = (params = {}, options = {}) => {
	return {
		de: de.launchpad__selection_title,
		en: en.launchpad__selection_title,
		es: es.launchpad__selection_title,
		fr: fr.launchpad__selection_title,
		it: it.launchpad__selection_title,
		nl: nl.launchpad__selection_title,
		pt: pt.launchpad__selection_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_cta_label = (params = {}, options = {}) => {
	return {
		de: de.launchpad__zois_cta_label,
		en: en.launchpad__zois_cta_label,
		es: es.launchpad__zois_cta_label,
		fr: fr.launchpad__zois_cta_label,
		it: it.launchpad__zois_cta_label,
		nl: nl.launchpad__zois_cta_label,
		pt: pt.launchpad__zois_cta_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_notification = (params = {}, options = {}) => {
	return {
		de: de.launchpad__zois_notification,
		en: en.launchpad__zois_notification,
		es: es.launchpad__zois_notification,
		fr: fr.launchpad__zois_notification,
		it: it.launchpad__zois_notification,
		nl: nl.launchpad__zois_notification,
		pt: pt.launchpad__zois_notification
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_title = (params = {}, options = {}) => {
	return {
		de: de.launchpad__zois_title,
		en: en.launchpad__zois_title,
		es: es.launchpad__zois_title,
		fr: fr.launchpad__zois_title,
		it: it.launchpad__zois_title,
		nl: nl.launchpad__zois_title,
		pt: pt.launchpad__zois_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__header = (params = {}, options = {}) => {
	return {
		de: de.layers__header,
		en: en.layers__header,
		es: es.layers__header,
		fr: fr.layers__header,
		it: it.layers__header,
		nl: nl.layers__header,
		pt: pt.layers__header
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__historic__image_alt = (params = {}, options = {}) => {
	return {
		de: de.layers__historic__image_alt,
		en: en.layers__historic__image_alt,
		es: es.layers__historic__image_alt,
		fr: fr.layers__historic__image_alt,
		it: it.layers__historic__image_alt,
		nl: nl.layers__historic__image_alt,
		pt: pt.layers__historic__image_alt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__historic__label = (params = {}, options = {}) => {
	return {
		de: de.layers__historic__label,
		en: en.layers__historic__label,
		es: es.layers__historic__label,
		fr: fr.layers__historic__label,
		it: it.layers__historic__label,
		nl: nl.layers__historic__label,
		pt: pt.layers__historic__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__hybrid__image_alt = (params = {}, options = {}) => {
	return {
		de: de.layers__hybrid__image_alt,
		en: en.layers__hybrid__image_alt,
		es: es.layers__hybrid__image_alt,
		fr: fr.layers__hybrid__image_alt,
		it: it.layers__hybrid__image_alt,
		nl: nl.layers__hybrid__image_alt,
		pt: pt.layers__hybrid__image_alt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__hybrid__label = (params = {}, options = {}) => {
	return {
		de: de.layers__hybrid__label,
		en: en.layers__hybrid__label,
		es: es.layers__hybrid__label,
		fr: fr.layers__hybrid__label,
		it: it.layers__hybrid__label,
		nl: nl.layers__hybrid__label,
		pt: pt.layers__hybrid__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__michelin__imagex_alt = (params = {}, options = {}) => {
	return {
		de: de.layers__michelin__imagex_alt,
		en: en.layers__michelin__imagex_alt,
		es: es.layers__michelin__imagex_alt,
		fr: fr.layers__michelin__imagex_alt,
		it: it.layers__michelin__imagex_alt,
		nl: nl.layers__michelin__imagex_alt,
		pt: pt.layers__michelin__imagex_alt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__michelin__label = (params = {}, options = {}) => {
	return {
		de: de.layers__michelin__label,
		en: en.layers__michelin__label,
		es: es.layers__michelin__label,
		fr: fr.layers__michelin__label,
		it: it.layers__michelin__label,
		nl: nl.layers__michelin__label,
		pt: pt.layers__michelin__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__scenic__imagex_alt = (params = {}, options = {}) => {
	return {
		de: de.layers__scenic__imagex_alt,
		en: en.layers__scenic__imagex_alt,
		es: es.layers__scenic__imagex_alt,
		fr: fr.layers__scenic__imagex_alt,
		it: it.layers__scenic__imagex_alt,
		nl: nl.layers__scenic__imagex_alt,
		pt: pt.layers__scenic__imagex_alt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__scenic__label = (params = {}, options = {}) => {
	return {
		de: de.layers__scenic__label,
		en: en.layers__scenic__label,
		es: es.layers__scenic__label,
		fr: fr.layers__scenic__label,
		it: it.layers__scenic__label,
		nl: nl.layers__scenic__label,
		pt: pt.layers__scenic__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__confidentiality_policy = (params = {}, options = {}) => {
	return {
		de: de.legal_link__confidentiality_policy,
		en: en.legal_link__confidentiality_policy,
		es: es.legal_link__confidentiality_policy,
		fr: fr.legal_link__confidentiality_policy,
		it: it.legal_link__confidentiality_policy,
		nl: nl.legal_link__confidentiality_policy,
		pt: pt.legal_link__confidentiality_policy
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__contact = (params = {}, options = {}) => {
	return {
		de: de.legal_link__contact,
		en: en.legal_link__contact,
		es: es.legal_link__contact,
		fr: fr.legal_link__contact,
		it: it.legal_link__contact,
		nl: nl.legal_link__contact,
		pt: pt.legal_link__contact
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__cookies = (params = {}, options = {}) => {
	return {
		de: de.legal_link__cookies,
		en: en.legal_link__cookies,
		es: es.legal_link__cookies,
		fr: fr.legal_link__cookies,
		it: it.legal_link__cookies,
		nl: nl.legal_link__cookies,
		pt: pt.legal_link__cookies
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__credits = (params = {}, options = {}) => {
	return {
		de: de.legal_link__credits,
		en: en.legal_link__credits,
		es: es.legal_link__credits,
		fr: fr.legal_link__credits,
		it: it.legal_link__credits,
		nl: nl.legal_link__credits,
		pt: pt.legal_link__credits
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__legal_notice = (params = {}, options = {}) => {
	return {
		de: de.legal_link__legal_notice,
		en: en.legal_link__legal_notice,
		es: es.legal_link__legal_notice,
		fr: fr.legal_link__legal_notice,
		it: it.legal_link__legal_notice,
		nl: nl.legal_link__legal_notice,
		pt: pt.legal_link__legal_notice
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__term_of_use = (params = {}, options = {}) => {
	return {
		de: de.legal_link__term_of_use,
		en: en.legal_link__term_of_use,
		es: es.legal_link__term_of_use,
		fr: fr.legal_link__term_of_use,
		it: it.legal_link__term_of_use,
		nl: nl.legal_link__term_of_use,
		pt: pt.legal_link__term_of_use
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__error = (params = {}, options = {}) => {
	return {
		de: de.location_control__error,
		en: en.location_control__error,
		es: es.location_control__error,
		fr: fr.location_control__error,
		it: it.location_control__error,
		nl: nl.location_control__error,
		pt: pt.location_control__error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__header = (params = {}, options = {}) => {
	return {
		de: de.location_control__tooltip__header,
		en: en.location_control__tooltip__header,
		es: es.location_control__tooltip__header,
		fr: fr.location_control__tooltip__header,
		it: it.location_control__tooltip__header,
		nl: nl.location_control__tooltip__header,
		pt: pt.location_control__tooltip__header
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__text = (params = {}, options = {}) => {
	return {
		de: de.location_control__tooltip__text,
		en: en.location_control__tooltip__text,
		es: es.location_control__tooltip__text,
		fr: fr.location_control__tooltip__text,
		it: it.location_control__tooltip__text,
		nl: nl.location_control__tooltip__text,
		pt: pt.location_control__tooltip__text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__close_button = (params = {}, options = {}) => {
	return {
		de: de.login_callback__close_button,
		en: en.login_callback__close_button,
		es: es.login_callback__close_button,
		fr: fr.login_callback__close_button,
		it: it.login_callback__close_button,
		nl: nl.login_callback__close_button,
		pt: pt.login_callback__close_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__failure = (params = {}, options = {}) => {
	return {
		de: de.login_callback__failure,
		en: en.login_callback__failure,
		es: es.login_callback__failure,
		fr: fr.login_callback__failure,
		it: it.login_callback__failure,
		nl: nl.login_callback__failure,
		pt: pt.login_callback__failure
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__success = (params = {}, options = {}) => {
	return {
		de: de.login_callback__success,
		en: en.login_callback__success,
		es: es.login_callback__success,
		fr: fr.login_callback__success,
		it: it.login_callback__success,
		nl: nl.login_callback__success,
		pt: pt.login_callback__success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__access_profile = (params = {}, options = {}) => {
	return {
		de: de.map_controls__aria_labels__access_profile,
		en: en.map_controls__aria_labels__access_profile,
		es: es.map_controls__aria_labels__access_profile,
		fr: fr.map_controls__aria_labels__access_profile,
		it: it.map_controls__aria_labels__access_profile,
		nl: nl.map_controls__aria_labels__access_profile,
		pt: pt.map_controls__aria_labels__access_profile
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__compass = (params = {}, options = {}) => {
	return {
		de: de.map_controls__aria_labels__compass,
		en: en.map_controls__aria_labels__compass,
		es: es.map_controls__aria_labels__compass,
		fr: fr.map_controls__aria_labels__compass,
		it: it.map_controls__aria_labels__compass,
		nl: nl.map_controls__aria_labels__compass,
		pt: pt.map_controls__aria_labels__compass
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__location = (params = {}, options = {}) => {
	return {
		de: de.map_controls__aria_labels__location,
		en: en.map_controls__aria_labels__location,
		es: es.map_controls__aria_labels__location,
		fr: fr.map_controls__aria_labels__location,
		it: it.map_controls__aria_labels__location,
		nl: nl.map_controls__aria_labels__location,
		pt: pt.map_controls__aria_labels__location
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__login_profile = (params = {}, options = {}) => {
	return {
		de: de.map_controls__aria_labels__login_profile,
		en: en.map_controls__aria_labels__login_profile,
		es: es.map_controls__aria_labels__login_profile,
		fr: fr.map_controls__aria_labels__login_profile,
		it: it.map_controls__aria_labels__login_profile,
		nl: nl.map_controls__aria_labels__login_profile,
		pt: pt.map_controls__aria_labels__login_profile
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__profile = (params = {}, options = {}) => {
	return {
		de: de.map_controls__aria_labels__profile,
		en: en.map_controls__aria_labels__profile,
		es: es.map_controls__aria_labels__profile,
		fr: fr.map_controls__aria_labels__profile,
		it: it.map_controls__aria_labels__profile,
		nl: nl.map_controls__aria_labels__profile,
		pt: pt.map_controls__aria_labels__profile
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__settings = (params = {}, options = {}) => {
	return {
		de: de.map_controls__aria_labels__settings,
		en: en.map_controls__aria_labels__settings,
		es: es.map_controls__aria_labels__settings,
		fr: fr.map_controls__aria_labels__settings,
		it: it.map_controls__aria_labels__settings,
		nl: nl.map_controls__aria_labels__settings,
		pt: pt.map_controls__aria_labels__settings
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__zoom_in = (params = {}, options = {}) => {
	return {
		de: de.map_controls__aria_labels__zoom_in,
		en: en.map_controls__aria_labels__zoom_in,
		es: es.map_controls__aria_labels__zoom_in,
		fr: fr.map_controls__aria_labels__zoom_in,
		it: it.map_controls__aria_labels__zoom_in,
		nl: nl.map_controls__aria_labels__zoom_in,
		pt: pt.map_controls__aria_labels__zoom_in
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__zoom_out = (params = {}, options = {}) => {
	return {
		de: de.map_controls__aria_labels__zoom_out,
		en: en.map_controls__aria_labels__zoom_out,
		es: es.map_controls__aria_labels__zoom_out,
		fr: fr.map_controls__aria_labels__zoom_out,
		it: it.map_controls__aria_labels__zoom_out,
		nl: nl.map_controls__aria_labels__zoom_out,
		pt: pt.map_controls__aria_labels__zoom_out
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel = (params = {}, options = {}) => {
	return {
		de: de.map_controls__partner_hotel,
		en: en.map_controls__partner_hotel,
		es: es.map_controls__partner_hotel,
		fr: fr.map_controls__partner_hotel,
		it: it.map_controls__partner_hotel,
		nl: nl.map_controls__partner_hotel,
		pt: pt.map_controls__partner_hotel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel__long_label = (params = {}, options = {}) => {
	return {
		de: de.map_controls__partner_hotel__long_label,
		en: en.map_controls__partner_hotel__long_label,
		es: es.map_controls__partner_hotel__long_label,
		fr: fr.map_controls__partner_hotel__long_label,
		it: it.map_controls__partner_hotel__long_label,
		nl: nl.map_controls__partner_hotel__long_label,
		pt: pt.map_controls__partner_hotel__long_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__go_to_traffic_info_page__label = (params = {}, options = {}) => {
	return {
		de: de.map_tools__go_to_traffic_info_page__label,
		en: en.map_tools__go_to_traffic_info_page__label,
		es: es.map_tools__go_to_traffic_info_page__label,
		fr: fr.map_tools__go_to_traffic_info_page__label,
		it: it.map_tools__go_to_traffic_info_page__label,
		nl: nl.map_tools__go_to_traffic_info_page__label,
		pt: pt.map_tools__go_to_traffic_info_page__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__low_emission_zone__label = (params = {}, options = {}) => {
	return {
		de: de.map_tools__low_emission_zone__label,
		en: en.map_tools__low_emission_zone__label,
		es: es.map_tools__low_emission_zone__label,
		fr: fr.map_tools__low_emission_zone__label,
		it: it.map_tools__low_emission_zone__label,
		nl: nl.map_tools__low_emission_zone__label,
		pt: pt.map_tools__low_emission_zone__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info__label = (params = {}, options = {}) => {
	return {
		de: de.map_tools__traffic_info__label,
		en: en.map_tools__traffic_info__label,
		es: es.map_tools__traffic_info__label,
		fr: fr.map_tools__traffic_info__label,
		it: it.map_tools__traffic_info__label,
		nl: nl.map_tools__traffic_info__label,
		pt: pt.map_tools__traffic_info__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_busy__label = (params = {}, options = {}) => {
	return {
		de: de.map_tools__traffic_info_busy__label,
		en: en.map_tools__traffic_info_busy__label,
		es: es.map_tools__traffic_info_busy__label,
		fr: fr.map_tools__traffic_info_busy__label,
		it: it.map_tools__traffic_info_busy__label,
		nl: nl.map_tools__traffic_info_busy__label,
		pt: pt.map_tools__traffic_info_busy__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_closed_lane__label = (params = {}, options = {}) => {
	return {
		de: de.map_tools__traffic_info_closed_lane__label,
		en: en.map_tools__traffic_info_closed_lane__label,
		es: es.map_tools__traffic_info_closed_lane__label,
		fr: fr.map_tools__traffic_info_closed_lane__label,
		it: it.map_tools__traffic_info_closed_lane__label,
		nl: nl.map_tools__traffic_info_closed_lane__label,
		pt: pt.map_tools__traffic_info_closed_lane__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_display_alerts__label = (params = {}, options = {}) => {
	return {
		de: de.map_tools__traffic_info_display_alerts__label,
		en: en.map_tools__traffic_info_display_alerts__label,
		es: es.map_tools__traffic_info_display_alerts__label,
		fr: fr.map_tools__traffic_info_display_alerts__label,
		it: it.map_tools__traffic_info_display_alerts__label,
		nl: nl.map_tools__traffic_info_display_alerts__label,
		pt: pt.map_tools__traffic_info_display_alerts__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_fluid__label = (params = {}, options = {}) => {
	return {
		de: de.map_tools__traffic_info_fluid__label,
		en: en.map_tools__traffic_info_fluid__label,
		es: es.map_tools__traffic_info_fluid__label,
		fr: fr.map_tools__traffic_info_fluid__label,
		it: it.map_tools__traffic_info_fluid__label,
		nl: nl.map_tools__traffic_info_fluid__label,
		pt: pt.map_tools__traffic_info_fluid__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_heavy__label = (params = {}, options = {}) => {
	return {
		de: de.map_tools__traffic_info_heavy__label,
		en: en.map_tools__traffic_info_heavy__label,
		es: es.map_tools__traffic_info_heavy__label,
		fr: fr.map_tools__traffic_info_heavy__label,
		it: it.map_tools__traffic_info_heavy__label,
		nl: nl.map_tools__traffic_info_heavy__label,
		pt: pt.map_tools__traffic_info_heavy__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__bookTheFork = (params = {}, options = {}) => {
	return {
		de: de.modal__bookTheFork,
		en: en.modal__bookTheFork,
		es: es.modal__bookTheFork,
		fr: fr.modal__bookTheFork,
		it: it.modal__bookTheFork,
		nl: nl.modal__bookTheFork,
		pt: pt.modal__bookTheFork
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__close = (params = {}, options = {}) => {
	return {
		de: de.modal__close,
		en: en.modal__close,
		es: es.modal__close,
		fr: fr.modal__close,
		it: it.modal__close,
		nl: nl.modal__close,
		pt: pt.modal__close
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__locale_switch_title = (params = {}, options = {}) => {
	return {
		de: de.modal__locale_switch_title,
		en: en.modal__locale_switch_title,
		es: es.modal__locale_switch_title,
		fr: fr.modal__locale_switch_title,
		it: it.modal__locale_switch_title,
		nl: nl.modal__locale_switch_title,
		pt: pt.modal__locale_switch_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const other_roads = (params = {}, options = {}) => {
	return {
		de: de.other_roads,
		en: en.other_roads,
		es: es.other_roads,
		fr: fr.other_roads,
		it: it.other_roads,
		nl: nl.other_roads,
		pt: pt.other_roads
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__first = (params = {}, options = {}) => {
	return {
		de: de.pagination__aria_labels__first,
		en: en.pagination__aria_labels__first,
		es: es.pagination__aria_labels__first,
		fr: fr.pagination__aria_labels__first,
		it: it.pagination__aria_labels__first,
		nl: nl.pagination__aria_labels__first,
		pt: pt.pagination__aria_labels__first
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__last = (params = {}, options = {}) => {
	return {
		de: de.pagination__aria_labels__last,
		en: en.pagination__aria_labels__last,
		es: es.pagination__aria_labels__last,
		fr: fr.pagination__aria_labels__last,
		it: it.pagination__aria_labels__last,
		nl: nl.pagination__aria_labels__last,
		pt: pt.pagination__aria_labels__last
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__nav = (params = {}, options = {}) => {
	return {
		de: de.pagination__aria_labels__nav,
		en: en.pagination__aria_labels__nav,
		es: es.pagination__aria_labels__nav,
		fr: fr.pagination__aria_labels__nav,
		it: it.pagination__aria_labels__nav,
		nl: nl.pagination__aria_labels__nav,
		pt: pt.pagination__aria_labels__nav
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__next = (params = {}, options = {}) => {
	return {
		de: de.pagination__aria_labels__next,
		en: en.pagination__aria_labels__next,
		es: es.pagination__aria_labels__next,
		fr: fr.pagination__aria_labels__next,
		it: it.pagination__aria_labels__next,
		nl: nl.pagination__aria_labels__next,
		pt: pt.pagination__aria_labels__next
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ page: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__page = (params , options = {}) => {
	return {
		de: de.pagination__aria_labels__page,
		en: en.pagination__aria_labels__page,
		es: es.pagination__aria_labels__page,
		fr: fr.pagination__aria_labels__page,
		it: it.pagination__aria_labels__page,
		nl: nl.pagination__aria_labels__page,
		pt: pt.pagination__aria_labels__page
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ page: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__page_active = (params , options = {}) => {
	return {
		de: de.pagination__aria_labels__page_active,
		en: en.pagination__aria_labels__page_active,
		es: es.pagination__aria_labels__page_active,
		fr: fr.pagination__aria_labels__page_active,
		it: it.pagination__aria_labels__page_active,
		nl: nl.pagination__aria_labels__page_active,
		pt: pt.pagination__aria_labels__page_active
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__prev = (params = {}, options = {}) => {
	return {
		de: de.pagination__aria_labels__prev,
		en: en.pagination__aria_labels__prev,
		es: es.pagination__aria_labels__prev,
		fr: fr.pagination__aria_labels__prev,
		it: it.pagination__aria_labels__prev,
		nl: nl.pagination__aria_labels__prev,
		pt: pt.pagination__aria_labels__prev
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__end_of_results = (params = {}, options = {}) => {
	return {
		de: de.pagination__end_of_results,
		en: en.pagination__end_of_results,
		es: es.pagination__end_of_results,
		fr: fr.pagination__end_of_results,
		it: it.pagination__end_of_results,
		nl: nl.pagination__end_of_results,
		pt: pt.pagination__end_of_results
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__next = (params = {}, options = {}) => {
	return {
		de: de.pagination__next,
		en: en.pagination__next,
		es: es.pagination__next,
		fr: fr.pagination__next,
		it: it.pagination__next,
		nl: nl.pagination__next,
		pt: pt.pagination__next
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__previous = (params = {}, options = {}) => {
	return {
		de: de.pagination__previous,
		en: en.pagination__previous,
		es: es.pagination__previous,
		fr: fr.pagination__previous,
		it: it.pagination__previous,
		nl: nl.pagination__previous,
		pt: pt.pagination__previous
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poiCard__seeDetails = (params = {}, options = {}) => {
	return {
		de: de.poiCard__seeDetails,
		en: en.poiCard__seeDetails,
		es: es.poiCard__seeDetails,
		fr: fr.poiCard__seeDetails,
		it: it.poiCard__seeDetails,
		nl: nl.poiCard__seeDetails,
		pt: pt.poiCard__seeDetails
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__activities = (params = {}, options = {}) => {
	return {
		de: de.poi_actions__activities,
		en: en.poi_actions__activities,
		es: es.poi_actions__activities,
		fr: fr.poi_actions__activities,
		it: it.poi_actions__activities,
		nl: nl.poi_actions__activities,
		pt: pt.poi_actions__activities
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__add_to_itinerary = (params = {}, options = {}) => {
	return {
		de: de.poi_actions__add_to_itinerary,
		en: en.poi_actions__add_to_itinerary,
		es: es.poi_actions__add_to_itinerary,
		fr: fr.poi_actions__add_to_itinerary,
		it: it.poi_actions__add_to_itinerary,
		nl: nl.poi_actions__add_to_itinerary,
		pt: pt.poi_actions__add_to_itinerary
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__book = (params = {}, options = {}) => {
	return {
		de: de.poi_actions__book,
		en: en.poi_actions__book,
		es: es.poi_actions__book,
		fr: fr.poi_actions__book,
		it: it.poi_actions__book,
		nl: nl.poi_actions__book,
		pt: pt.poi_actions__book
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__cancel = (params = {}, options = {}) => {
	return {
		de: de.poi_actions__cancel,
		en: en.poi_actions__cancel,
		es: es.poi_actions__cancel,
		fr: fr.poi_actions__cancel,
		it: it.poi_actions__cancel,
		nl: nl.poi_actions__cancel,
		pt: pt.poi_actions__cancel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__details = (params = {}, options = {}) => {
	return {
		de: de.poi_actions__details,
		en: en.poi_actions__details,
		es: es.poi_actions__details,
		fr: fr.poi_actions__details,
		it: it.poi_actions__details,
		nl: nl.poi_actions__details,
		pt: pt.poi_actions__details
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__itinerary = (params = {}, options = {}) => {
	return {
		de: de.poi_actions__itinerary,
		en: en.poi_actions__itinerary,
		es: es.poi_actions__itinerary,
		fr: fr.poi_actions__itinerary,
		it: it.poi_actions__itinerary,
		nl: nl.poi_actions__itinerary,
		pt: pt.poi_actions__itinerary
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__actions_book = (params = {}, options = {}) => {
	return {
		de: de.poi_card__actions_book,
		en: en.poi_card__actions_book,
		es: es.poi_card__actions_book,
		fr: fr.poi_card__actions_book,
		it: it.poi_card__actions_book,
		nl: nl.poi_card__actions_book,
		pt: pt.poi_card__actions_book
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ average: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__average_price = (params , options = {}) => {
	return {
		de: de.poi_card__average_price,
		en: en.poi_card__average_price,
		es: es.poi_card__average_price,
		fr: fr.poi_card__average_price,
		it: it.poi_card__average_price,
		nl: nl.poi_card__average_price,
		pt: pt.poi_card__average_price
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ price: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__book_min_price = (params , options = {}) => {
	return {
		de: de.poi_card__book_min_price,
		en: en.poi_card__book_min_price,
		es: es.poi_card__book_min_price,
		fr: fr.poi_card__book_min_price,
		it: it.poi_card__book_min_price,
		nl: nl.poi_card__book_min_price,
		pt: pt.poi_card__book_min_price
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__aria_label = (params = {}, options = {}) => {
	return {
		de: de.poi_card__carousel__aria_label,
		en: en.poi_card__carousel__aria_label,
		es: es.poi_card__carousel__aria_label,
		fr: fr.poi_card__carousel__aria_label,
		it: it.poi_card__carousel__aria_label,
		nl: nl.poi_card__carousel__aria_label,
		pt: pt.poi_card__carousel__aria_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__list_aria_label = (params , options = {}) => {
	return {
		de: de.poi_card__carousel__list_aria_label,
		en: en.poi_card__carousel__list_aria_label,
		es: es.poi_card__carousel__list_aria_label,
		fr: fr.poi_card__carousel__list_aria_label,
		it: it.poi_card__carousel__list_aria_label,
		nl: nl.poi_card__carousel__list_aria_label,
		pt: pt.poi_card__carousel__list_aria_label
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__next_button = (params = {}, options = {}) => {
	return {
		de: de.poi_card__carousel__next_button,
		en: en.poi_card__carousel__next_button,
		es: es.poi_card__carousel__next_button,
		fr: fr.poi_card__carousel__next_button,
		it: it.poi_card__carousel__next_button,
		nl: nl.poi_card__carousel__next_button,
		pt: pt.poi_card__carousel__next_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__prev_button = (params = {}, options = {}) => {
	return {
		de: de.poi_card__carousel__prev_button,
		en: en.poi_card__carousel__prev_button,
		es: es.poi_card__carousel__prev_button,
		fr: fr.poi_card__carousel__prev_button,
		it: it.poi_card__carousel__prev_button,
		nl: nl.poi_card__carousel__prev_button,
		pt: pt.poi_card__carousel__prev_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__charging_power__many = (params , options = {}) => {
	return {
		de: de.poi_card__charging_power__many,
		en: en.poi_card__charging_power__many,
		es: es.poi_card__charging_power__many,
		fr: fr.poi_card__charging_power__many,
		it: it.poi_card__charging_power__many,
		nl: nl.poi_card__charging_power__many,
		pt: pt.poi_card__charging_power__many
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__charging_power__one = (params , options = {}) => {
	return {
		de: de.poi_card__charging_power__one,
		en: en.poi_card__charging_power__one,
		es: es.poi_card__charging_power__one,
		fr: fr.poi_card__charging_power__one,
		it: it.poi_card__charging_power__one,
		nl: nl.poi_card__charging_power__one,
		pt: pt.poi_card__charging_power__one
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__count_more_than_3_connectors = (params , options = {}) => {
	return {
		de: de.poi_card__count_more_than_3_connectors,
		en: en.poi_card__count_more_than_3_connectors,
		es: es.poi_card__count_more_than_3_connectors,
		fr: fr.poi_card__count_more_than_3_connectors,
		it: it.poi_card__count_more_than_3_connectors,
		nl: nl.poi_card__count_more_than_3_connectors,
		pt: pt.poi_card__count_more_than_3_connectors
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__image_alt = (params = {}, options = {}) => {
	return {
		de: de.poi_card__image_alt,
		en: en.poi_card__image_alt,
		es: es.poi_card__image_alt,
		fr: fr.poi_card__image_alt,
		it: it.poi_card__image_alt,
		nl: nl.poi_card__image_alt,
		pt: pt.poi_card__image_alt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__michelin = (params = {}, options = {}) => {
	return {
		de: de.poi_card__michelin,
		en: en.poi_card__michelin,
		es: es.poi_card__michelin,
		fr: fr.poi_card__michelin,
		it: it.poi_card__michelin,
		nl: nl.poi_card__michelin,
		pt: pt.poi_card__michelin
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ min: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__min_price = (params , options = {}) => {
	return {
		de: de.poi_card__min_price,
		en: en.poi_card__min_price,
		es: es.poi_card__min_price,
		fr: fr.poi_card__min_price,
		it: it.poi_card__min_price,
		nl: nl.poi_card__min_price,
		pt: pt.poi_card__min_price
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__non_availability = (params = {}, options = {}) => {
	return {
		de: de.poi_card__non_availability,
		en: en.poi_card__non_availability,
		es: es.poi_card__non_availability,
		fr: fr.poi_card__non_availability,
		it: it.poi_card__non_availability,
		nl: nl.poi_card__non_availability,
		pt: pt.poi_card__non_availability
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__price_tag_average = (params = {}, options = {}) => {
	return {
		de: de.poi_card__price_tag_average,
		en: en.poi_card__price_tag_average,
		es: es.poi_card__price_tag_average,
		fr: fr.poi_card__price_tag_average,
		it: it.poi_card__price_tag_average,
		nl: nl.poi_card__price_tag_average,
		pt: pt.poi_card__price_tag_average
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__price_unavailable = (params = {}, options = {}) => {
	return {
		de: de.poi_card__price_unavailable,
		en: en.poi_card__price_unavailable,
		es: es.poi_card__price_unavailable,
		fr: fr.poi_card__price_unavailable,
		it: it.poi_card__price_unavailable,
		nl: nl.poi_card__price_unavailable,
		pt: pt.poi_card__price_unavailable
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__bad = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__bad,
		en: en.poi_card__review__bad,
		es: es.poi_card__review__bad,
		fr: fr.poi_card__review__bad,
		it: it.poi_card__review__bad,
		nl: nl.poi_card__review__bad,
		pt: pt.poi_card__review__bad
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__disappointing = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__disappointing,
		en: en.poi_card__review__disappointing,
		es: es.poi_card__review__disappointing,
		fr: fr.poi_card__review__disappointing,
		it: it.poi_card__review__disappointing,
		nl: nl.poi_card__review__disappointing,
		pt: pt.poi_card__review__disappointing
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__exceptional = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__exceptional,
		en: en.poi_card__review__exceptional,
		es: es.poi_card__review__exceptional,
		fr: fr.poi_card__review__exceptional,
		it: it.poi_card__review__exceptional,
		nl: nl.poi_card__review__exceptional,
		pt: pt.poi_card__review__exceptional
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__fabulous = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__fabulous,
		en: en.poi_card__review__fabulous,
		es: es.poi_card__review__fabulous,
		fr: fr.poi_card__review__fabulous,
		it: it.poi_card__review__fabulous,
		nl: nl.poi_card__review__fabulous,
		pt: pt.poi_card__review__fabulous
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__good = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__good,
		en: en.poi_card__review__good,
		es: es.poi_card__review__good,
		fr: fr.poi_card__review__good,
		it: it.poi_card__review__good,
		nl: nl.poi_card__review__good,
		pt: pt.poi_card__review__good
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__mediocre = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__mediocre,
		en: en.poi_card__review__mediocre,
		es: es.poi_card__review__mediocre,
		fr: fr.poi_card__review__mediocre,
		it: it.poi_card__review__mediocre,
		nl: nl.poi_card__review__mediocre,
		pt: pt.poi_card__review__mediocre
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__passable = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__passable,
		en: en.poi_card__review__passable,
		es: es.poi_card__review__passable,
		fr: fr.poi_card__review__passable,
		it: it.poi_card__review__passable,
		nl: nl.poi_card__review__passable,
		pt: pt.poi_card__review__passable
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__pleasant = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__pleasant,
		en: en.poi_card__review__pleasant,
		es: es.poi_card__review__pleasant,
		fr: fr.poi_card__review__pleasant,
		it: it.poi_card__review__pleasant,
		nl: nl.poi_card__review__pleasant,
		pt: pt.poi_card__review__pleasant
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__quite_mediocre = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__quite_mediocre,
		en: en.poi_card__review__quite_mediocre,
		es: es.poi_card__review__quite_mediocre,
		fr: fr.poi_card__review__quite_mediocre,
		it: it.poi_card__review__quite_mediocre,
		nl: nl.poi_card__review__quite_mediocre,
		pt: pt.poi_card__review__quite_mediocre
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__superb = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__superb,
		en: en.poi_card__review__superb,
		es: es.poi_card__review__superb,
		fr: fr.poi_card__review__superb,
		it: it.poi_card__review__superb,
		nl: nl.poi_card__review__superb,
		pt: pt.poi_card__review__superb
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__very_good = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__very_good,
		en: en.poi_card__review__very_good,
		es: es.poi_card__review__very_good,
		fr: fr.poi_card__review__very_good,
		it: it.poi_card__review__very_good,
		nl: nl.poi_card__review__very_good,
		pt: pt.poi_card__review__very_good
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__well = (params = {}, options = {}) => {
	return {
		de: de.poi_card__review__well,
		en: en.poi_card__review__well,
		es: es.poi_card__review__well,
		fr: fr.poi_card__review__well,
		it: it.poi_card__review__well,
		nl: nl.poi_card__review__well,
		pt: pt.poi_card__review__well
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review_count = (params , options = {}) => {
	return {
		de: de.poi_card__review_count,
		en: en.poi_card__review_count,
		es: es.poi_card__review_count,
		fr: fr.poi_card__review_count,
		it: it.poi_card__review_count,
		nl: nl.poi_card__review_count,
		pt: pt.poi_card__review_count
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ date: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__updated = (params , options = {}) => {
	return {
		de: de.poi_card__updated,
		en: en.poi_card__updated,
		es: es.poi_card__updated,
		fr: fr.poi_card__updated,
		it: it.poi_card__updated,
		nl: nl.poi_card__updated,
		pt: pt.poi_card__updated
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__accommodation = (params = {}, options = {}) => {
	return {
		de: de.poi_categories__accommodation,
		en: en.poi_categories__accommodation,
		es: es.poi_categories__accommodation,
		fr: fr.poi_categories__accommodation,
		it: it.poi_categories__accommodation,
		nl: nl.poi_categories__accommodation,
		pt: pt.poi_categories__accommodation
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__ev_service = (params = {}, options = {}) => {
	return {
		de: de.poi_categories__ev_service,
		en: en.poi_categories__ev_service,
		es: es.poi_categories__ev_service,
		fr: fr.poi_categories__ev_service,
		it: it.poi_categories__ev_service,
		nl: nl.poi_categories__ev_service,
		pt: pt.poi_categories__ev_service
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__gas_station = (params = {}, options = {}) => {
	return {
		de: de.poi_categories__gas_station,
		en: en.poi_categories__gas_station,
		es: es.poi_categories__gas_station,
		fr: fr.poi_categories__gas_station,
		it: it.poi_categories__gas_station,
		nl: nl.poi_categories__gas_station,
		pt: pt.poi_categories__gas_station
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__parking = (params = {}, options = {}) => {
	return {
		de: de.poi_categories__parking,
		en: en.poi_categories__parking,
		es: es.poi_categories__parking,
		fr: fr.poi_categories__parking,
		it: it.poi_categories__parking,
		nl: nl.poi_categories__parking,
		pt: pt.poi_categories__parking
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__rest_stop = (params = {}, options = {}) => {
	return {
		de: de.poi_categories__rest_stop,
		en: en.poi_categories__rest_stop,
		es: es.poi_categories__rest_stop,
		fr: fr.poi_categories__rest_stop,
		it: it.poi_categories__rest_stop,
		nl: nl.poi_categories__rest_stop,
		pt: pt.poi_categories__rest_stop
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__restaurant = (params = {}, options = {}) => {
	return {
		de: de.poi_categories__restaurant,
		en: en.poi_categories__restaurant,
		es: es.poi_categories__restaurant,
		fr: fr.poi_categories__restaurant,
		it: it.poi_categories__restaurant,
		nl: nl.poi_categories__restaurant,
		pt: pt.poi_categories__restaurant
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__tourism = (params = {}, options = {}) => {
	return {
		de: de.poi_categories__tourism,
		en: en.poi_categories__tourism,
		es: es.poi_categories__tourism,
		fr: fr.poi_categories__tourism,
		it: it.poi_categories__tourism,
		nl: nl.poi_categories__tourism,
		pt: pt.poi_categories__tourism
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__header = (params = {}, options = {}) => {
	return {
		de: de.poi_category_settings__header,
		en: en.poi_category_settings__header,
		es: es.poi_category_settings__header,
		fr: fr.poi_category_settings__header,
		it: it.poi_category_settings__header,
		nl: nl.poi_category_settings__header,
		pt: pt.poi_category_settings__header
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__not_available = (params = {}, options = {}) => {
	return {
		de: de.poi_category_settings__not_available,
		en: en.poi_category_settings__not_available,
		es: es.poi_category_settings__not_available,
		fr: fr.poi_category_settings__not_available,
		it: it.poi_category_settings__not_available,
		nl: nl.poi_category_settings__not_available,
		pt: pt.poi_category_settings__not_available
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__select_all = (params = {}, options = {}) => {
	return {
		de: de.poi_category_settings__select_all,
		en: en.poi_category_settings__select_all,
		es: es.poi_category_settings__select_all,
		fr: fr.poi_category_settings__select_all,
		it: it.poi_category_settings__select_all,
		nl: nl.poi_category_settings__select_all,
		pt: pt.poi_category_settings__select_all
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__unselect_all = (params = {}, options = {}) => {
	return {
		de: de.poi_category_settings__unselect_all,
		en: en.poi_category_settings__unselect_all,
		es: es.poi_category_settings__unselect_all,
		fr: fr.poi_category_settings__unselect_all,
		it: it.poi_category_settings__unselect_all,
		nl: nl.poi_category_settings__unselect_all,
		pt: pt.poi_category_settings__unselect_all
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availabilities__many__overnight_stay = (params , options = {}) => {
	return {
		de: de.poi_datasheet__availabilities__many__overnight_stay,
		en: en.poi_datasheet__availabilities__many__overnight_stay,
		es: es.poi_datasheet__availabilities__many__overnight_stay,
		fr: fr.poi_datasheet__availabilities__many__overnight_stay,
		it: it.poi_datasheet__availabilities__many__overnight_stay,
		nl: nl.poi_datasheet__availabilities__many__overnight_stay,
		pt: pt.poi_datasheet__availabilities__many__overnight_stay
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availabilities__one__overnight_stay = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__availabilities__one__overnight_stay,
		en: en.poi_datasheet__availabilities__one__overnight_stay,
		es: es.poi_datasheet__availabilities__one__overnight_stay,
		fr: fr.poi_datasheet__availabilities__one__overnight_stay,
		it: it.poi_datasheet__availabilities__one__overnight_stay,
		nl: nl.poi_datasheet__availabilities__one__overnight_stay,
		pt: pt.poi_datasheet__availabilities__one__overnight_stay
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__availability,
		en: en.poi_datasheet__availability,
		es: es.poi_datasheet__availability,
		fr: fr.poi_datasheet__availability,
		it: it.poi_datasheet__availability,
		nl: nl.poi_datasheet__availability,
		pt: pt.poi_datasheet__availability
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__error = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__availability__error,
		en: en.poi_datasheet__availability__error,
		es: es.poi_datasheet__availability__error,
		fr: fr.poi_datasheet__availability__error,
		it: it.poi_datasheet__availability__error,
		nl: nl.poi_datasheet__availability__error,
		pt: pt.poi_datasheet__availability__error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view__many__other = (params , options = {}) => {
	return {
		de: de.poi_datasheet__availability__view__many__other,
		en: en.poi_datasheet__availability__view__many__other,
		es: es.poi_datasheet__availability__view__many__other,
		fr: fr.poi_datasheet__availability__view__many__other,
		it: it.poi_datasheet__availability__view__many__other,
		nl: nl.poi_datasheet__availability__view__many__other,
		pt: pt.poi_datasheet__availability__view__many__other
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view__one__other = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__availability__view__one__other,
		en: en.poi_datasheet__availability__view__one__other,
		es: es.poi_datasheet__availability__view__one__other,
		fr: fr.poi_datasheet__availability__view__one__other,
		it: it.poi_datasheet__availability__view__one__other,
		nl: nl.poi_datasheet__availability__view__one__other,
		pt: pt.poi_datasheet__availability__view__one__other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view_more__on_partner_website = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__availability__view_more__on_partner_website,
		en: en.poi_datasheet__availability__view_more__on_partner_website,
		es: es.poi_datasheet__availability__view_more__on_partner_website,
		fr: fr.poi_datasheet__availability__view_more__on_partner_website,
		it: it.poi_datasheet__availability__view_more__on_partner_website,
		nl: nl.poi_datasheet__availability__view_more__on_partner_website,
		pt: pt.poi_datasheet__availability__view_more__on_partner_website
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__with = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__availability__with,
		en: en.poi_datasheet__availability__with,
		es: es.poi_datasheet__availability__with,
		fr: fr.poi_datasheet__availability__with,
		it: it.poi_datasheet__availability__with,
		nl: nl.poi_datasheet__availability__with,
		pt: pt.poi_datasheet__availability__with
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability_offer = (params , options = {}) => {
	return {
		de: de.poi_datasheet__availability_offer,
		en: en.poi_datasheet__availability_offer,
		es: es.poi_datasheet__availability_offer,
		fr: fr.poi_datasheet__availability_offer,
		it: it.poi_datasheet__availability_offer,
		nl: nl.poi_datasheet__availability_offer,
		pt: pt.poi_datasheet__availability_offer
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__back_to_list = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__back_to_list,
		en: en.poi_datasheet__back_to_list,
		es: es.poi_datasheet__back_to_list,
		fr: fr.poi_datasheet__back_to_list,
		it: it.poi_datasheet__back_to_list,
		nl: nl.poi_datasheet__back_to_list,
		pt: pt.poi_datasheet__back_to_list
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__carousel__close_button = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__carousel__close_button,
		en: en.poi_datasheet__carousel__close_button,
		es: es.poi_datasheet__carousel__close_button,
		fr: fr.poi_datasheet__carousel__close_button,
		it: it.poi_datasheet__carousel__close_button,
		nl: nl.poi_datasheet__carousel__close_button,
		pt: pt.poi_datasheet__carousel__close_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__description = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__description,
		en: en.poi_datasheet__description,
		es: es.poi_datasheet__description,
		fr: fr.poi_datasheet__description,
		it: it.poi_datasheet__description,
		nl: nl.poi_datasheet__description,
		pt: pt.poi_datasheet__description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__bb = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__highlight__accommodation_subtype__bb,
		en: en.poi_datasheet__highlight__accommodation_subtype__bb,
		es: es.poi_datasheet__highlight__accommodation_subtype__bb,
		fr: fr.poi_datasheet__highlight__accommodation_subtype__bb,
		it: it.poi_datasheet__highlight__accommodation_subtype__bb,
		nl: nl.poi_datasheet__highlight__accommodation_subtype__bb,
		pt: pt.poi_datasheet__highlight__accommodation_subtype__bb
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__camping = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__highlight__accommodation_subtype__camping,
		en: en.poi_datasheet__highlight__accommodation_subtype__camping,
		es: es.poi_datasheet__highlight__accommodation_subtype__camping,
		fr: fr.poi_datasheet__highlight__accommodation_subtype__camping,
		it: it.poi_datasheet__highlight__accommodation_subtype__camping,
		nl: nl.poi_datasheet__highlight__accommodation_subtype__camping,
		pt: pt.poi_datasheet__highlight__accommodation_subtype__camping
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__hotel = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__highlight__accommodation_subtype__hotel,
		en: en.poi_datasheet__highlight__accommodation_subtype__hotel,
		es: es.poi_datasheet__highlight__accommodation_subtype__hotel,
		fr: fr.poi_datasheet__highlight__accommodation_subtype__hotel,
		it: it.poi_datasheet__highlight__accommodation_subtype__hotel,
		nl: nl.poi_datasheet__highlight__accommodation_subtype__hotel,
		pt: pt.poi_datasheet__highlight__accommodation_subtype__hotel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__residence = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__highlight__accommodation_subtype__residence,
		en: en.poi_datasheet__highlight__accommodation_subtype__residence,
		es: es.poi_datasheet__highlight__accommodation_subtype__residence,
		fr: fr.poi_datasheet__highlight__accommodation_subtype__residence,
		it: it.poi_datasheet__highlight__accommodation_subtype__residence,
		nl: nl.poi_datasheet__highlight__accommodation_subtype__residence,
		pt: pt.poi_datasheet__highlight__accommodation_subtype__residence
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__rest_stop__rest = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__highlight__rest_stop__rest,
		en: en.poi_datasheet__highlight__rest_stop__rest,
		es: es.poi_datasheet__highlight__rest_stop__rest,
		fr: fr.poi_datasheet__highlight__rest_stop__rest,
		it: it.poi_datasheet__highlight__rest_stop__rest,
		nl: nl.poi_datasheet__highlight__rest_stop__rest,
		pt: pt.poi_datasheet__highlight__rest_stop__rest
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__rest_stop__service = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__highlight__rest_stop__service,
		en: en.poi_datasheet__highlight__rest_stop__service,
		es: es.poi_datasheet__highlight__rest_stop__service,
		fr: fr.poi_datasheet__highlight__rest_stop__service,
		it: it.poi_datasheet__highlight__rest_stop__service,
		nl: nl.poi_datasheet__highlight__rest_stop__service,
		pt: pt.poi_datasheet__highlight__rest_stop__service
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__image_alt = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__image_alt,
		en: en.poi_datasheet__image_alt,
		es: es.poi_datasheet__image_alt,
		fr: fr.poi_datasheet__image_alt,
		it: it.poi_datasheet__image_alt,
		nl: nl.poi_datasheet__image_alt,
		pt: pt.poi_datasheet__image_alt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__location = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__location,
		en: en.poi_datasheet__location,
		es: es.poi_datasheet__location,
		fr: fr.poi_datasheet__location,
		it: it.poi_datasheet__location,
		nl: nl.poi_datasheet__location,
		pt: pt.poi_datasheet__location
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__michelin_opinion = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__michelin_opinion,
		en: en.poi_datasheet__michelin_opinion,
		es: es.poi_datasheet__michelin_opinion,
		fr: fr.poi_datasheet__michelin_opinion,
		it: it.poi_datasheet__michelin_opinion,
		nl: nl.poi_datasheet__michelin_opinion,
		pt: pt.poi_datasheet__michelin_opinion
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__michelin_opinion__tourism = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__michelin_opinion__tourism,
		en: en.poi_datasheet__michelin_opinion__tourism,
		es: es.poi_datasheet__michelin_opinion__tourism,
		fr: fr.poi_datasheet__michelin_opinion__tourism,
		it: it.poi_datasheet__michelin_opinion__tourism,
		nl: nl.poi_datasheet__michelin_opinion__tourism,
		pt: pt.poi_datasheet__michelin_opinion__tourism
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__practical_info = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__practical_info,
		en: en.poi_datasheet__practical_info,
		es: es.poi_datasheet__practical_info,
		fr: fr.poi_datasheet__practical_info,
		it: it.poi_datasheet__practical_info,
		nl: nl.poi_datasheet__practical_info,
		pt: pt.poi_datasheet__practical_info
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label,
		en: en.poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label,
		es: es.poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label,
		fr: fr.poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label,
		it: it.poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label,
		nl: nl.poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label,
		pt: pt.poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__recommendation__getyourguide__tours_not_found,
		en: en.poi_datasheet__recommendation__getyourguide__tours_not_found,
		es: es.poi_datasheet__recommendation__getyourguide__tours_not_found,
		fr: fr.poi_datasheet__recommendation__getyourguide__tours_not_found,
		it: it.poi_datasheet__recommendation__getyourguide__tours_not_found,
		nl: nl.poi_datasheet__recommendation__getyourguide__tours_not_found,
		pt: pt.poi_datasheet__recommendation__getyourguide__tours_not_found
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_with_region = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__recommendation__getyourguide__tours_not_found_with_region,
		en: en.poi_datasheet__recommendation__getyourguide__tours_not_found_with_region,
		es: es.poi_datasheet__recommendation__getyourguide__tours_not_found_with_region,
		fr: fr.poi_datasheet__recommendation__getyourguide__tours_not_found_with_region,
		it: it.poi_datasheet__recommendation__getyourguide__tours_not_found_with_region,
		nl: nl.poi_datasheet__recommendation__getyourguide__tours_not_found_with_region,
		pt: pt.poi_datasheet__recommendation__getyourguide__tours_not_found_with_region
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region,
		en: en.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region,
		es: es.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region,
		fr: fr.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region,
		it: it.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region,
		nl: nl.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region,
		pt: pt.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label,
		en: en.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label,
		es: es.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label,
		fr: fr.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label,
		it: it.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label,
		nl: nl.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label,
		pt: pt.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__not_found_image_alt = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__recommendation__not_found_image_alt,
		en: en.poi_datasheet__recommendation__not_found_image_alt,
		es: es.poi_datasheet__recommendation__not_found_image_alt,
		fr: fr.poi_datasheet__recommendation__not_found_image_alt,
		it: it.poi_datasheet__recommendation__not_found_image_alt,
		nl: nl.poi_datasheet__recommendation__not_found_image_alt,
		pt: pt.poi_datasheet__recommendation__not_found_image_alt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__title = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__recommendation__title,
		en: en.poi_datasheet__recommendation__title,
		es: es.poi_datasheet__recommendation__title,
		fr: fr.poi_datasheet__recommendation__title,
		it: it.poi_datasheet__recommendation__title,
		nl: nl.poi_datasheet__recommendation__title,
		pt: pt.poi_datasheet__recommendation__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__see_more = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__see_more,
		en: en.poi_datasheet__see_more,
		es: es.poi_datasheet__see_more,
		fr: fr.poi_datasheet__see_more,
		it: it.poi_datasheet__see_more,
		nl: nl.poi_datasheet__see_more,
		pt: pt.poi_datasheet__see_more
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__see_on_map = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__see_on_map,
		en: en.poi_datasheet__see_on_map,
		es: es.poi_datasheet__see_on_map,
		fr: fr.poi_datasheet__see_on_map,
		it: it.poi_datasheet__see_on_map,
		nl: nl.poi_datasheet__see_on_map,
		pt: pt.poi_datasheet__see_on_map
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__strong_points = (params = {}, options = {}) => {
	return {
		de: de.poi_datasheet__strong_points,
		en: en.poi_datasheet__strong_points,
		es: es.poi_datasheet__strong_points,
		fr: fr.poi_datasheet__strong_points,
		it: it.poi_datasheet__strong_points,
		nl: nl.poi_datasheet__strong_points,
		pt: pt.poi_datasheet__strong_points
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__back = (params = {}, options = {}) => {
	return {
		de: de.poi_filters__back,
		en: en.poi_filters__back,
		es: es.poi_filters__back,
		fr: fr.poi_filters__back,
		it: it.poi_filters__back,
		nl: nl.poi_filters__back,
		pt: pt.poi_filters__back
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__detailed_view__label = (params = {}, options = {}) => {
	return {
		de: de.poi_filters__detailed_view__label,
		en: en.poi_filters__detailed_view__label,
		es: es.poi_filters__detailed_view__label,
		fr: fr.poi_filters__detailed_view__label,
		it: it.poi_filters__detailed_view__label,
		nl: nl.poi_filters__detailed_view__label,
		pt: pt.poi_filters__detailed_view__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__fetch_error = (params = {}, options = {}) => {
	return {
		de: de.poi_filters__fetch_error,
		en: en.poi_filters__fetch_error,
		es: es.poi_filters__fetch_error,
		fr: fr.poi_filters__fetch_error,
		it: it.poi_filters__fetch_error,
		nl: nl.poi_filters__fetch_error,
		pt: pt.poi_filters__fetch_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__no_selected_categories = (params = {}, options = {}) => {
	return {
		de: de.poi_filters__no_selected_categories,
		en: en.poi_filters__no_selected_categories,
		es: es.poi_filters__no_selected_categories,
		fr: fr.poi_filters__no_selected_categories,
		it: it.poi_filters__no_selected_categories,
		nl: nl.poi_filters__no_selected_categories,
		pt: pt.poi_filters__no_selected_categories
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__only__michelin = (params = {}, options = {}) => {
	return {
		de: de.poi_filters__only__michelin,
		en: en.poi_filters__only__michelin,
		es: es.poi_filters__only__michelin,
		fr: fr.poi_filters__only__michelin,
		it: it.poi_filters__only__michelin,
		nl: nl.poi_filters__only__michelin,
		pt: pt.poi_filters__only__michelin
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__select_to_filter = (params = {}, options = {}) => {
	return {
		de: de.poi_filters__select_to_filter,
		en: en.poi_filters__select_to_filter,
		es: es.poi_filters__select_to_filter,
		fr: fr.poi_filters__select_to_filter,
		it: it.poi_filters__select_to_filter,
		nl: nl.poi_filters__select_to_filter,
		pt: pt.poi_filters__select_to_filter
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__all = (params = {}, options = {}) => {
	return {
		de: de.poi_filters__selected_items__all,
		en: en.poi_filters__selected_items__all,
		es: es.poi_filters__selected_items__all,
		fr: fr.poi_filters__selected_items__all,
		it: it.poi_filters__selected_items__all,
		nl: nl.poi_filters__selected_items__all,
		pt: pt.poi_filters__selected_items__all
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__many = (params , options = {}) => {
	return {
		de: de.poi_filters__selected_items__many,
		en: en.poi_filters__selected_items__many,
		es: es.poi_filters__selected_items__many,
		fr: fr.poi_filters__selected_items__many,
		it: it.poi_filters__selected_items__many,
		nl: nl.poi_filters__selected_items__many,
		pt: pt.poi_filters__selected_items__many
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__none = (params = {}, options = {}) => {
	return {
		de: de.poi_filters__selected_items__none,
		en: en.poi_filters__selected_items__none,
		es: es.poi_filters__selected_items__none,
		fr: fr.poi_filters__selected_items__none,
		it: it.poi_filters__selected_items__none,
		nl: nl.poi_filters__selected_items__none,
		pt: pt.poi_filters__selected_items__none
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__one = (params = {}, options = {}) => {
	return {
		de: de.poi_filters__selected_items__one,
		en: en.poi_filters__selected_items__one,
		es: es.poi_filters__selected_items__one,
		fr: fr.poi_filters__selected_items__one,
		it: it.poi_filters__selected_items__one,
		nl: nl.poi_filters__selected_items__one,
		pt: pt.poi_filters__selected_items__one
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ hours: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__last_update = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__last_update,
		en: en.poi_filters__value_label__last_update,
		es: es.poi_filters__value_label__last_update,
		fr: fr.poi_filters__value_label__last_update,
		it: it.poi_filters__value_label__last_update,
		nl: nl.poi_filters__value_label__last_update,
		pt: pt.poi_filters__value_label__last_update
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_count = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__min_count,
		en: en.poi_filters__value_label__min_count,
		es: es.poi_filters__value_label__min_count,
		fr: fr.poi_filters__value_label__min_count,
		it: it.poi_filters__value_label__min_count,
		nl: nl.poi_filters__value_label__min_count,
		pt: pt.poi_filters__value_label__min_count
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ power: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_power = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__min_power,
		en: en.poi_filters__value_label__min_power,
		es: es.poi_filters__value_label__min_power,
		fr: fr.poi_filters__value_label__min_power,
		it: it.poi_filters__value_label__min_power,
		nl: nl.poi_filters__value_label__min_power,
		pt: pt.poi_filters__value_label__min_power
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ amount: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_price__eur = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__min_price__eur,
		en: en.poi_filters__value_label__min_price__eur,
		es: es.poi_filters__value_label__min_price__eur,
		fr: fr.poi_filters__value_label__min_price__eur,
		it: it.poi_filters__value_label__min_price__eur,
		nl: nl.poi_filters__value_label__min_price__eur,
		pt: pt.poi_filters__value_label__min_price__eur
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ amount: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_price__usd = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__min_price__usd,
		en: en.poi_filters__value_label__min_price__usd,
		es: es.poi_filters__value_label__min_price__usd,
		fr: fr.poi_filters__value_label__min_price__usd,
		it: it.poi_filters__value_label__min_price__usd,
		nl: nl.poi_filters__value_label__min_price__usd,
		pt: pt.poi_filters__value_label__min_price__usd
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ minRate: NonNullable<unknown>, maxRate: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_rate = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__min_rate,
		en: en.poi_filters__value_label__min_rate,
		es: es.poi_filters__value_label__min_rate,
		fr: fr.poi_filters__value_label__min_rate,
		it: it.poi_filters__value_label__min_rate,
		nl: nl.poi_filters__value_label__min_rate,
		pt: pt.poi_filters__value_label__min_rate
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_stars__one = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__min_stars__one,
		en: en.poi_filters__value_label__min_stars__one,
		es: es.poi_filters__value_label__min_stars__one,
		fr: fr.poi_filters__value_label__min_stars__one,
		it: it.poi_filters__value_label__min_stars__one,
		nl: nl.poi_filters__value_label__min_stars__one,
		pt: pt.poi_filters__value_label__min_stars__one
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_stars__other = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__min_stars__other,
		en: en.poi_filters__value_label__min_stars__other,
		es: es.poi_filters__value_label__min_stars__other,
		fr: fr.poi_filters__value_label__min_stars__other,
		it: it.poi_filters__value_label__min_stars__other,
		nl: nl.poi_filters__value_label__min_stars__other,
		pt: pt.poi_filters__value_label__min_stars__other
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__none = (params = {}, options = {}) => {
	return {
		de: de.poi_filters__value_label__none,
		en: en.poi_filters__value_label__none,
		es: es.poi_filters__value_label__none,
		fr: fr.poi_filters__value_label__none,
		it: it.poi_filters__value_label__none,
		nl: nl.poi_filters__value_label__none,
		pt: pt.poi_filters__value_label__none
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ amount: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price__eur = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__price__eur,
		en: en.poi_filters__value_label__price__eur,
		es: es.poi_filters__value_label__price__eur,
		fr: fr.poi_filters__value_label__price__eur,
		it: it.poi_filters__value_label__price__eur,
		nl: nl.poi_filters__value_label__price__eur,
		pt: pt.poi_filters__value_label__price__eur
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ amount: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price__usd = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__price__usd,
		en: en.poi_filters__value_label__price__usd,
		es: es.poi_filters__value_label__price__usd,
		fr: fr.poi_filters__value_label__price__usd,
		it: it.poi_filters__value_label__price__usd,
		nl: nl.poi_filters__value_label__price__usd,
		pt: pt.poi_filters__value_label__price__usd
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price_range__eur = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__price_range__eur,
		en: en.poi_filters__value_label__price_range__eur,
		es: es.poi_filters__value_label__price_range__eur,
		fr: fr.poi_filters__value_label__price_range__eur,
		it: it.poi_filters__value_label__price_range__eur,
		nl: nl.poi_filters__value_label__price_range__eur,
		pt: pt.poi_filters__value_label__price_range__eur
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price_range__usd = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__price_range__usd,
		en: en.poi_filters__value_label__price_range__usd,
		es: es.poi_filters__value_label__price_range__usd,
		fr: fr.poi_filters__value_label__price_range__usd,
		it: it.poi_filters__value_label__price_range__usd,
		nl: nl.poi_filters__value_label__price_range__usd,
		pt: pt.poi_filters__value_label__price_range__usd
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__stars = (params , options = {}) => {
	return {
		de: de.poi_filters__value_label__stars,
		en: en.poi_filters__value_label__stars,
		es: es.poi_filters__value_label__stars,
		fr: fr.poi_filters__value_label__stars,
		it: it.poi_filters__value_label__stars,
		nl: nl.poi_filters__value_label__stars,
		pt: pt.poi_filters__value_label__stars
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button = (params = {}, options = {}) => {
	return {
		de: de.poi_list__aria_label__filter_button,
		en: en.poi_list__aria_label__filter_button,
		es: es.poi_list__aria_label__filter_button,
		fr: fr.poi_list__aria_label__filter_button,
		it: it.poi_list__aria_label__filter_button,
		nl: nl.poi_list__aria_label__filter_button,
		pt: pt.poi_list__aria_label__filter_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ numberOfFilters: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__many = (params , options = {}) => {
	return {
		de: de.poi_list__aria_label__filter_button_filtered__many,
		en: en.poi_list__aria_label__filter_button_filtered__many,
		es: es.poi_list__aria_label__filter_button_filtered__many,
		fr: fr.poi_list__aria_label__filter_button_filtered__many,
		it: it.poi_list__aria_label__filter_button_filtered__many,
		nl: nl.poi_list__aria_label__filter_button_filtered__many,
		pt: pt.poi_list__aria_label__filter_button_filtered__many
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ numberOfFilters: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__one = (params , options = {}) => {
	return {
		de: de.poi_list__aria_label__filter_button_filtered__one,
		en: en.poi_list__aria_label__filter_button_filtered__one,
		es: es.poi_list__aria_label__filter_button_filtered__one,
		fr: fr.poi_list__aria_label__filter_button_filtered__one,
		it: it.poi_list__aria_label__filter_button_filtered__one,
		nl: nl.poi_list__aria_label__filter_button_filtered__one,
		pt: pt.poi_list__aria_label__filter_button_filtered__one
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_category = (params = {}, options = {}) => {
	return {
		de: de.poi_list__errors__no_category,
		en: en.poi_list__errors__no_category,
		es: es.poi_list__errors__no_category,
		fr: fr.poi_list__errors__no_category,
		it: it.poi_list__errors__no_category,
		nl: nl.poi_list__errors__no_category,
		pt: pt.poi_list__errors__no_category
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_result = (params = {}, options = {}) => {
	return {
		de: de.poi_list__errors__no_result,
		en: en.poi_list__errors__no_result,
		es: es.poi_list__errors__no_result,
		fr: fr.poi_list__errors__no_result,
		it: it.poi_list__errors__no_result,
		nl: nl.poi_list__errors__no_result,
		pt: pt.poi_list__errors__no_result
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__filters__toggle_label = (params = {}, options = {}) => {
	return {
		de: de.poi_list__filters__toggle_label,
		en: en.poi_list__filters__toggle_label,
		es: es.poi_list__filters__toggle_label,
		fr: fr.poi_list__filters__toggle_label,
		it: it.poi_list__filters__toggle_label,
		nl: nl.poi_list__filters__toggle_label,
		pt: pt.poi_list__filters__toggle_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_marker__pin = (params = {}, options = {}) => {
	return {
		de: de.poi_marker__pin,
		en: en.poi_marker__pin,
		es: es.poi_marker__pin,
		fr: fr.poi_marker__pin,
		it: it.poi_marker__pin,
		nl: nl.poi_marker__pin,
		pt: pt.poi_marker__pin
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_search_category__aria_label = (params = {}, options = {}) => {
	return {
		de: de.poi_search_category__aria_label,
		en: en.poi_search_category__aria_label,
		es: es.poi_search_category__aria_label,
		fr: fr.poi_search_category__aria_label,
		it: it.poi_search_category__aria_label,
		nl: nl.poi_search_category__aria_label,
		pt: pt.poi_search_category__aria_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__close = (params = {}, options = {}) => {
	return {
		de: de.profile__close,
		en: en.profile__close,
		es: es.profile__close,
		fr: fr.profile__close,
		it: it.profile__close,
		nl: nl.profile__close,
		pt: pt.profile__close
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__login = (params = {}, options = {}) => {
	return {
		de: de.profile__login,
		en: en.profile__login,
		es: es.profile__login,
		fr: fr.profile__login,
		it: it.profile__login,
		nl: nl.profile__login,
		pt: pt.profile__login
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__logout = (params = {}, options = {}) => {
	return {
		de: de.profile__logout,
		en: en.profile__logout,
		es: es.profile__logout,
		fr: fr.profile__logout,
		it: it.profile__logout,
		nl: nl.profile__logout,
		pt: pt.profile__logout
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__favorites__title = (params = {}, options = {}) => {
	return {
		de: de.profile__tabs__favorites__title,
		en: en.profile__tabs__favorites__title,
		es: es.profile__tabs__favorites__title,
		fr: fr.profile__tabs__favorites__title,
		it: it.profile__tabs__favorites__title,
		nl: nl.profile__tabs__favorites__title,
		pt: pt.profile__tabs__favorites__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__banner = (params = {}, options = {}) => {
	return {
		de: de.profile__tabs__information__banner,
		en: en.profile__tabs__information__banner,
		es: es.profile__tabs__information__banner,
		fr: fr.profile__tabs__information__banner,
		it: it.profile__tabs__information__banner,
		nl: nl.profile__tabs__information__banner,
		pt: pt.profile__tabs__information__banner
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__email = (params = {}, options = {}) => {
	return {
		de: de.profile__tabs__information__form__email,
		en: en.profile__tabs__information__form__email,
		es: es.profile__tabs__information__form__email,
		fr: fr.profile__tabs__information__form__email,
		it: it.profile__tabs__information__form__email,
		nl: nl.profile__tabs__information__form__email,
		pt: pt.profile__tabs__information__form__email
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__name = (params = {}, options = {}) => {
	return {
		de: de.profile__tabs__information__form__name,
		en: en.profile__tabs__information__form__name,
		es: es.profile__tabs__information__form__name,
		fr: fr.profile__tabs__information__form__name,
		it: it.profile__tabs__information__form__name,
		nl: nl.profile__tabs__information__form__name,
		pt: pt.profile__tabs__information__form__name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__password = (params = {}, options = {}) => {
	return {
		de: de.profile__tabs__information__form__password,
		en: en.profile__tabs__information__form__password,
		es: es.profile__tabs__information__form__password,
		fr: fr.profile__tabs__information__form__password,
		it: it.profile__tabs__information__form__password,
		nl: nl.profile__tabs__information__form__password,
		pt: pt.profile__tabs__information__form__password
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__modify = (params = {}, options = {}) => {
	return {
		de: de.profile__tabs__information__modify,
		en: en.profile__tabs__information__modify,
		es: es.profile__tabs__information__modify,
		fr: fr.profile__tabs__information__modify,
		it: it.profile__tabs__information__modify,
		nl: nl.profile__tabs__information__modify,
		pt: pt.profile__tabs__information__modify
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__title = (params = {}, options = {}) => {
	return {
		de: de.profile__tabs__information__title,
		en: en.profile__tabs__information__title,
		es: es.profile__tabs__information__title,
		fr: fr.profile__tabs__information__title,
		it: it.profile__tabs__information__title,
		nl: nl.profile__tabs__information__title,
		pt: pt.profile__tabs__information__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__banner = (params = {}, options = {}) => {
	return {
		de: de.profile__tabs__settings__banner,
		en: en.profile__tabs__settings__banner,
		es: es.profile__tabs__settings__banner,
		fr: fr.profile__tabs__settings__banner,
		it: it.profile__tabs__settings__banner,
		nl: nl.profile__tabs__settings__banner,
		pt: pt.profile__tabs__settings__banner
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__title = (params = {}, options = {}) => {
	return {
		de: de.profile__tabs__settings__title,
		en: en.profile__tabs__settings__title,
		es: es.profile__tabs__settings__title,
		fr: fr.profile__tabs__settings__title,
		it: it.profile__tabs__settings__title,
		nl: nl.profile__tabs__settings__title,
		pt: pt.profile__tabs__settings__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__vehicle = (params = {}, options = {}) => {
	return {
		de: de.profile__tabs__settings__vehicle,
		en: en.profile__tabs__settings__vehicle,
		es: es.profile__tabs__settings__vehicle,
		fr: fr.profile__tabs__settings__vehicle,
		it: it.profile__tabs__settings__vehicle,
		nl: nl.profile__tabs__settings__vehicle,
		pt: pt.profile__tabs__settings__vehicle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const refresh_control__label = (params = {}, options = {}) => {
	return {
		de: de.refresh_control__label,
		en: en.refresh_control__label,
		es: es.refresh_control__label,
		fr: fr.refresh_control__label,
		it: it.refresh_control__label,
		nl: nl.refresh_control__label,
		pt: pt.refresh_control__label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__construction_year = (params = {}, options = {}) => {
	return {
		de: de.register__car__construction_year,
		en: en.register__car__construction_year,
		es: es.register__car__construction_year,
		fr: fr.register__car__construction_year,
		it: it.register__car__construction_year,
		nl: nl.register__car__construction_year,
		pt: pt.register__car__construction_year
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__fuel = (params = {}, options = {}) => {
	return {
		de: de.register__car__fuel,
		en: en.register__car__fuel,
		es: es.register__car__fuel,
		fr: fr.register__car__fuel,
		it: it.register__car__fuel,
		nl: nl.register__car__fuel,
		pt: pt.register__car__fuel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__text = (params = {}, options = {}) => {
	return {
		de: de.register__car__info_box__text,
		en: en.register__car__info_box__text,
		es: es.register__car__info_box__text,
		fr: fr.register__car__info_box__text,
		it: it.register__car__info_box__text,
		nl: nl.register__car__info_box__text,
		pt: pt.register__car__info_box__text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__title = (params = {}, options = {}) => {
	return {
		de: de.register__car__info_box__title,
		en: en.register__car__info_box__title,
		es: es.register__car__info_box__title,
		fr: fr.register__car__info_box__title,
		it: it.register__car__info_box__title,
		nl: nl.register__car__info_box__title,
		pt: pt.register__car__info_box__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__motor = (params = {}, options = {}) => {
	return {
		de: de.register__car__motor,
		en: en.register__car__motor,
		es: es.register__car__motor,
		fr: fr.register__car__motor,
		it: it.register__car__motor,
		nl: nl.register__car__motor,
		pt: pt.register__car__motor
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_subtitle = (params = {}, options = {}) => {
	return {
		de: de.register_car__account_subtitle,
		en: en.register_car__account_subtitle,
		es: es.register_car__account_subtitle,
		fr: fr.register_car__account_subtitle,
		it: it.register_car__account_subtitle,
		nl: nl.register_car__account_subtitle,
		pt: pt.register_car__account_subtitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_title = (params = {}, options = {}) => {
	return {
		de: de.register_car__account_title,
		en: en.register_car__account_title,
		es: es.register_car__account_title,
		fr: fr.register_car__account_title,
		it: it.register_car__account_title,
		nl: nl.register_car__account_title,
		pt: pt.register_car__account_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__fill_to_save = (params = {}, options = {}) => {
	return {
		de: de.register_car__fill_to_save,
		en: en.register_car__fill_to_save,
		es: es.register_car__fill_to_save,
		fr: fr.register_car__fill_to_save,
		it: it.register_car__fill_to_save,
		nl: nl.register_car__fill_to_save,
		pt: pt.register_car__fill_to_save
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_error = (params = {}, options = {}) => {
	return {
		de: de.register_car__register_error,
		en: en.register_car__register_error,
		es: es.register_car__register_error,
		fr: fr.register_car__register_error,
		it: it.register_car__register_error,
		nl: nl.register_car__register_error,
		pt: pt.register_car__register_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_success = (params = {}, options = {}) => {
	return {
		de: de.register_car__register_success,
		en: en.register_car__register_success,
		es: es.register_car__register_success,
		fr: fr.register_car__register_success,
		it: it.register_car__register_success,
		nl: nl.register_car__register_success,
		pt: pt.register_car__register_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__search_placeholder = (params = {}, options = {}) => {
	return {
		de: de.register_car__search_placeholder,
		en: en.register_car__search_placeholder,
		es: es.register_car__search_placeholder,
		fr: fr.register_car__search_placeholder,
		it: it.register_car__search_placeholder,
		nl: nl.register_car__search_placeholder,
		pt: pt.register_car__search_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__vehicle = (params = {}, options = {}) => {
	return {
		de: de.register_car__vehicle,
		en: en.register_car__vehicle,
		es: es.register_car__vehicle,
		fr: fr.register_car__vehicle,
		it: it.register_car__vehicle,
		nl: nl.register_car__vehicle,
		pt: pt.register_car__vehicle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__dogArea = (params = {}, options = {}) => {
	return {
		de: de.restStopService__dogArea,
		en: en.restStopService__dogArea,
		es: es.restStopService__dogArea,
		fr: fr.restStopService__dogArea,
		it: it.restStopService__dogArea,
		nl: nl.restStopService__dogArea,
		pt: pt.restStopService__dogArea
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__nursery = (params = {}, options = {}) => {
	return {
		de: de.restStopService__nursery,
		en: en.restStopService__nursery,
		es: es.restStopService__nursery,
		fr: fr.restStopService__nursery,
		it: it.restStopService__nursery,
		nl: nl.restStopService__nursery,
		pt: pt.restStopService__nursery
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__picnicTable = (params = {}, options = {}) => {
	return {
		de: de.restStopService__picnicTable,
		en: en.restStopService__picnicTable,
		es: es.restStopService__picnicTable,
		fr: fr.restStopService__picnicTable,
		it: it.restStopService__picnicTable,
		nl: nl.restStopService__picnicTable,
		pt: pt.restStopService__picnicTable
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__playGround = (params = {}, options = {}) => {
	return {
		de: de.restStopService__playGround,
		en: en.restStopService__playGround,
		es: es.restStopService__playGround,
		fr: fr.restStopService__playGround,
		it: it.restStopService__playGround,
		nl: nl.restStopService__playGround,
		pt: pt.restStopService__playGround
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__restaurant = (params = {}, options = {}) => {
	return {
		de: de.restStopService__restaurant,
		en: en.restStopService__restaurant,
		es: es.restStopService__restaurant,
		fr: fr.restStopService__restaurant,
		it: it.restStopService__restaurant,
		nl: nl.restStopService__restaurant,
		pt: pt.restStopService__restaurant
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__shop = (params = {}, options = {}) => {
	return {
		de: de.restStopService__shop,
		en: en.restStopService__shop,
		es: es.restStopService__shop,
		fr: fr.restStopService__shop,
		it: it.restStopService__shop,
		nl: nl.restStopService__shop,
		pt: pt.restStopService__shop
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restaurantMichelin_greenStarLabel = (params = {}, options = {}) => {
	return {
		de: de.restaurantMichelin_greenStarLabel,
		en: en.restaurantMichelin_greenStarLabel,
		es: es.restaurantMichelin_greenStarLabel,
		fr: fr.restaurantMichelin_greenStarLabel,
		it: it.restaurantMichelin_greenStarLabel,
		nl: nl.restaurantMichelin_greenStarLabel,
		pt: pt.restaurantMichelin_greenStarLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const road__detailed_instructions = (params = {}, options = {}) => {
	return {
		de: de.road__detailed_instructions,
		en: en.road__detailed_instructions,
		es: es.road__detailed_instructions,
		fr: fr.road__detailed_instructions,
		it: it.road__detailed_instructions,
		nl: nl.road__detailed_instructions,
		pt: pt.road__detailed_instructions
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const road__distribution_routes = (params = {}, options = {}) => {
	return {
		de: de.road__distribution_routes,
		en: en.road__distribution_routes,
		es: es.road__distribution_routes,
		fr: fr.road__distribution_routes,
		it: it.road__distribution_routes,
		nl: nl.road__distribution_routes,
		pt: pt.road__distribution_routes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const road_typology = (params = {}, options = {}) => {
	return {
		de: de.road_typology,
		en: en.road_typology,
		es: es.road_typology,
		fr: fr.road_typology,
		it: it.road_typology,
		nl: nl.road_typology,
		pt: pt.road_typology
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roadsheet__scenic_roads = (params = {}, options = {}) => {
	return {
		de: de.roadsheet__scenic_roads,
		en: en.roadsheet__scenic_roads,
		es: es.roadsheet__scenic_roads,
		fr: fr.roadsheet__scenic_roads,
		it: it.roadsheet__scenic_roads,
		nl: nl.roadsheet__scenic_roads,
		pt: pt.roadsheet__scenic_roads
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__arrival = (params = {}, options = {}) => {
	return {
		de: de.route__arrival,
		en: en.route__arrival,
		es: es.route__arrival,
		fr: fr.route__arrival,
		it: it.route__arrival,
		nl: nl.route__arrival,
		pt: pt.route__arrival
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__alternative = (params = {}, options = {}) => {
	return {
		de: de.route__badge__alternative,
		en: en.route__badge__alternative,
		es: es.route__badge__alternative,
		fr: fr.route__badge__alternative,
		it: it.route__badge__alternative,
		nl: nl.route__badge__alternative,
		pt: pt.route__badge__alternative
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__discovery = (params = {}, options = {}) => {
	return {
		de: de.route__badge__discovery,
		en: en.route__badge__discovery,
		es: es.route__badge__discovery,
		fr: fr.route__badge__discovery,
		it: it.route__badge__discovery,
		nl: nl.route__badge__discovery,
		pt: pt.route__badge__discovery
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__ecological = (params = {}, options = {}) => {
	return {
		de: de.route__badge__ecological,
		en: en.route__badge__ecological,
		es: es.route__badge__ecological,
		fr: fr.route__badge__ecological,
		it: it.route__badge__ecological,
		nl: nl.route__badge__ecological,
		pt: pt.route__badge__ecological
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__economic = (params = {}, options = {}) => {
	return {
		de: de.route__badge__economic,
		en: en.route__badge__economic,
		es: es.route__badge__economic,
		fr: fr.route__badge__economic,
		it: it.route__badge__economic,
		nl: nl.route__badge__economic,
		pt: pt.route__badge__economic
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__quickest = (params = {}, options = {}) => {
	return {
		de: de.route__badge__quickest,
		en: en.route__badge__quickest,
		es: es.route__badge__quickest,
		fr: fr.route__badge__quickest,
		it: it.route__badge__quickest,
		nl: nl.route__badge__quickest,
		pt: pt.route__badge__quickest
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__shortest = (params = {}, options = {}) => {
	return {
		de: de.route__badge__shortest,
		en: en.route__badge__shortest,
		es: es.route__badge__shortest,
		fr: fr.route__badge__shortest,
		it: it.route__badge__shortest,
		nl: nl.route__badge__shortest,
		pt: pt.route__badge__shortest
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__departure = (params = {}, options = {}) => {
	return {
		de: de.route__departure,
		en: en.route__departure,
		es: es.route__departure,
		fr: fr.route__departure,
		it: it.route__departure,
		nl: nl.route__departure,
		pt: pt.route__departure
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__details = (params = {}, options = {}) => {
	return {
		de: de.route__details,
		en: en.route__details,
		es: es.route__details,
		fr: fr.route__details,
		it: it.route__details,
		nl: nl.route__details,
		pt: pt.route__details
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__error = (params = {}, options = {}) => {
	return {
		de: de.route__error,
		en: en.route__error,
		es: es.route__error,
		fr: fr.route__error,
		it: it.route__error,
		nl: nl.route__error,
		pt: pt.route__error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__final_charge = (params = {}, options = {}) => {
	return {
		de: de.route__final_charge,
		en: en.route__final_charge,
		es: es.route__final_charge,
		fr: fr.route__final_charge,
		it: it.route__final_charge,
		nl: nl.route__final_charge,
		pt: pt.route__final_charge
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ tollCost: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__included_costs = (params , options = {}) => {
	return {
		de: de.route__included_costs,
		en: en.route__included_costs,
		es: es.route__included_costs,
		fr: fr.route__included_costs,
		it: it.route__included_costs,
		nl: nl.route__included_costs,
		pt: pt.route__included_costs
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__itineraries__many = (params , options = {}) => {
	return {
		de: de.route__itineraries__many,
		en: en.route__itineraries__many,
		es: es.route__itineraries__many,
		fr: fr.route__itineraries__many,
		it: it.route__itineraries__many,
		nl: nl.route__itineraries__many,
		pt: pt.route__itineraries__many
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__itineraries__one = (params , options = {}) => {
	return {
		de: de.route__itineraries__one,
		en: en.route__itineraries__one,
		es: es.route__itineraries__one,
		fr: fr.route__itineraries__one,
		it: it.route__itineraries__one,
		nl: nl.route__itineraries__one,
		pt: pt.route__itineraries__one
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__not_found = (params = {}, options = {}) => {
	return {
		de: de.route__not_found,
		en: en.route__not_found,
		es: es.route__not_found,
		fr: fr.route__not_found,
		it: it.route__not_found,
		nl: nl.route__not_found,
		pt: pt.route__not_found
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__recharge = (params , options = {}) => {
	return {
		de: de.route__recharge,
		en: en.route__recharge,
		es: es.route__recharge,
		fr: fr.route__recharge,
		it: it.route__recharge,
		nl: nl.route__recharge,
		pt: pt.route__recharge
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__restrictions_tip__selected = (params = {}, options = {}) => {
	return {
		de: de.route__restrictions_tip__selected,
		en: en.route__restrictions_tip__selected,
		es: es.route__restrictions_tip__selected,
		fr: fr.route__restrictions_tip__selected,
		it: it.route__restrictions_tip__selected,
		nl: nl.route__restrictions_tip__selected,
		pt: pt.route__restrictions_tip__selected
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__restrictions_tip__unselected = (params = {}, options = {}) => {
	return {
		de: de.route__restrictions_tip__unselected,
		en: en.route__restrictions_tip__unselected,
		es: es.route__restrictions_tip__unselected,
		fr: fr.route__restrictions_tip__unselected,
		it: it.route__restrictions_tip__unselected,
		nl: nl.route__restrictions_tip__unselected,
		pt: pt.route__restrictions_tip__unselected
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_cost = (params = {}, options = {}) => {
	return {
		de: de.route__route_selector__column_cost,
		en: en.route__route_selector__column_cost,
		es: es.route__route_selector__column_cost,
		fr: fr.route__route_selector__column_cost,
		it: it.route__route_selector__column_cost,
		nl: nl.route__route_selector__column_cost,
		pt: pt.route__route_selector__column_cost
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_distance = (params = {}, options = {}) => {
	return {
		de: de.route__route_selector__column_distance,
		en: en.route__route_selector__column_distance,
		es: es.route__route_selector__column_distance,
		fr: fr.route__route_selector__column_distance,
		it: it.route__route_selector__column_distance,
		nl: nl.route__route_selector__column_distance,
		pt: pt.route__route_selector__column_distance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_duration = (params = {}, options = {}) => {
	return {
		de: de.route__route_selector__column_duration,
		en: en.route__route_selector__column_duration,
		es: es.route__route_selector__column_duration,
		fr: fr.route__route_selector__column_duration,
		it: it.route__route_selector__column_duration,
		nl: nl.route__route_selector__column_duration,
		pt: pt.route__route_selector__column_duration
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_electricity_consumption = (params = {}, options = {}) => {
	return {
		de: de.route__route_selector__column_electricity_consumption,
		en: en.route__route_selector__column_electricity_consumption,
		es: es.route__route_selector__column_electricity_consumption,
		fr: fr.route__route_selector__column_electricity_consumption,
		it: it.route__route_selector__column_electricity_consumption,
		nl: nl.route__route_selector__column_electricity_consumption,
		pt: pt.route__route_selector__column_electricity_consumption
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_emission = (params = {}, options = {}) => {
	return {
		de: de.route__route_selector__column_emission,
		en: en.route__route_selector__column_emission,
		es: es.route__route_selector__column_emission,
		fr: fr.route__route_selector__column_emission,
		it: it.route__route_selector__column_emission,
		nl: nl.route__route_selector__column_emission,
		pt: pt.route__route_selector__column_emission
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_error_message = (params = {}, options = {}) => {
	return {
		de: de.route__route_selector_error_message,
		en: en.route__route_selector_error_message,
		es: es.route__route_selector_error_message,
		fr: fr.route__route_selector_error_message,
		it: it.route__route_selector_error_message,
		nl: nl.route__route_selector_error_message,
		pt: pt.route__route_selector_error_message
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_address = (params = {}, options = {}) => {
	return {
		de: de.route__route_selector_no_address,
		en: en.route__route_selector_no_address,
		es: es.route__route_selector_no_address,
		fr: fr.route__route_selector_no_address,
		it: it.route__route_selector_no_address,
		nl: nl.route__route_selector_no_address,
		pt: pt.route__route_selector_no_address
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_road = (params = {}, options = {}) => {
	return {
		de: de.route__route_selector_no_road,
		en: en.route__route_selector_no_road,
		es: es.route__route_selector_no_road,
		fr: fr.route__route_selector_no_road,
		it: it.route__route_selector_no_road,
		nl: nl.route__route_selector_no_road,
		pt: pt.route__route_selector_no_road
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__alternative = (params = {}, options = {}) => {
	return {
		de: de.route__routemarkers__ariaLabel__alternative,
		en: en.route__routemarkers__ariaLabel__alternative,
		es: es.route__routemarkers__ariaLabel__alternative,
		fr: fr.route__routemarkers__ariaLabel__alternative,
		it: it.route__routemarkers__ariaLabel__alternative,
		nl: nl.route__routemarkers__ariaLabel__alternative,
		pt: pt.route__routemarkers__ariaLabel__alternative
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__default = (params = {}, options = {}) => {
	return {
		de: de.route__routemarkers__ariaLabel__default,
		en: en.route__routemarkers__ariaLabel__default,
		es: es.route__routemarkers__ariaLabel__default,
		fr: fr.route__routemarkers__ariaLabel__default,
		it: it.route__routemarkers__ariaLabel__default,
		nl: nl.route__routemarkers__ariaLabel__default,
		pt: pt.route__routemarkers__ariaLabel__default
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__discovery = (params = {}, options = {}) => {
	return {
		de: de.route__routemarkers__ariaLabel__discovery,
		en: en.route__routemarkers__ariaLabel__discovery,
		es: es.route__routemarkers__ariaLabel__discovery,
		fr: fr.route__routemarkers__ariaLabel__discovery,
		it: it.route__routemarkers__ariaLabel__discovery,
		nl: nl.route__routemarkers__ariaLabel__discovery,
		pt: pt.route__routemarkers__ariaLabel__discovery
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__ecological = (params = {}, options = {}) => {
	return {
		de: de.route__routemarkers__ariaLabel__ecological,
		en: en.route__routemarkers__ariaLabel__ecological,
		es: es.route__routemarkers__ariaLabel__ecological,
		fr: fr.route__routemarkers__ariaLabel__ecological,
		it: it.route__routemarkers__ariaLabel__ecological,
		nl: nl.route__routemarkers__ariaLabel__ecological,
		pt: pt.route__routemarkers__ariaLabel__ecological
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__economic = (params = {}, options = {}) => {
	return {
		de: de.route__routemarkers__ariaLabel__economic,
		en: en.route__routemarkers__ariaLabel__economic,
		es: es.route__routemarkers__ariaLabel__economic,
		fr: fr.route__routemarkers__ariaLabel__economic,
		it: it.route__routemarkers__ariaLabel__economic,
		nl: nl.route__routemarkers__ariaLabel__economic,
		pt: pt.route__routemarkers__ariaLabel__economic
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__quickest = (params = {}, options = {}) => {
	return {
		de: de.route__routemarkers__ariaLabel__quickest,
		en: en.route__routemarkers__ariaLabel__quickest,
		es: es.route__routemarkers__ariaLabel__quickest,
		fr: fr.route__routemarkers__ariaLabel__quickest,
		it: it.route__routemarkers__ariaLabel__quickest,
		nl: nl.route__routemarkers__ariaLabel__quickest,
		pt: pt.route__routemarkers__ariaLabel__quickest
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__shortest = (params = {}, options = {}) => {
	return {
		de: de.route__routemarkers__ariaLabel__shortest,
		en: en.route__routemarkers__ariaLabel__shortest,
		es: es.route__routemarkers__ariaLabel__shortest,
		fr: fr.route__routemarkers__ariaLabel__shortest,
		it: it.route__routemarkers__ariaLabel__shortest,
		nl: nl.route__routemarkers__ariaLabel__shortest,
		pt: pt.route__routemarkers__ariaLabel__shortest
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__step = (params = {}, options = {}) => {
	return {
		de: de.route__step,
		en: en.route__step,
		es: es.route__step,
		fr: fr.route__step,
		it: it.route__step,
		nl: nl.route__step,
		pt: pt.route__step
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs = (params = {}, options = {}) => {
	return {
		de: de.route_details__costs,
		en: en.route_details__costs,
		es: es.route_details__costs,
		fr: fr.route_details__costs,
		it: it.route_details__costs,
		nl: nl.route_details__costs,
		pt: pt.route_details__costs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__costs_details = (params = {}, options = {}) => {
	return {
		de: de.route_details__costs_section__costs_details,
		en: en.route_details__costs_section__costs_details,
		es: es.route_details__costs_section__costs_details,
		fr: fr.route_details__costs_section__costs_details,
		it: it.route_details__costs_section__costs_details,
		nl: nl.route_details__costs_section__costs_details,
		pt: pt.route_details__costs_section__costs_details
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__electricity = (params = {}, options = {}) => {
	return {
		de: de.route_details__costs_section__electricity,
		en: en.route_details__costs_section__electricity,
		es: es.route_details__costs_section__electricity,
		fr: fr.route_details__costs_section__electricity,
		it: it.route_details__costs_section__electricity,
		nl: nl.route_details__costs_section__electricity,
		pt: pt.route_details__costs_section__electricity
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__estimated_for = (params = {}, options = {}) => {
	return {
		de: de.route_details__costs_section__estimated_for,
		en: en.route_details__costs_section__estimated_for,
		es: es.route_details__costs_section__estimated_for,
		fr: fr.route_details__costs_section__estimated_for,
		it: it.route_details__costs_section__estimated_for,
		nl: nl.route_details__costs_section__estimated_for,
		pt: pt.route_details__costs_section__estimated_for
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__fuel = (params = {}, options = {}) => {
	return {
		de: de.route_details__costs_section__fuel,
		en: en.route_details__costs_section__fuel,
		es: es.route_details__costs_section__fuel,
		fr: fr.route_details__costs_section__fuel,
		it: it.route_details__costs_section__fuel,
		nl: nl.route_details__costs_section__fuel,
		pt: pt.route_details__costs_section__fuel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__tolls = (params = {}, options = {}) => {
	return {
		de: de.route_details__costs_section__tolls,
		en: en.route_details__costs_section__tolls,
		es: es.route_details__costs_section__tolls,
		fr: fr.route_details__costs_section__tolls,
		it: it.route_details__costs_section__tolls,
		nl: nl.route_details__costs_section__tolls,
		pt: pt.route_details__costs_section__tolls
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__tolls_list = (params = {}, options = {}) => {
	return {
		de: de.route_details__costs_section__tolls_list,
		en: en.route_details__costs_section__tolls_list,
		es: es.route_details__costs_section__tolls_list,
		fr: fr.route_details__costs_section__tolls_list,
		it: it.route_details__costs_section__tolls_list,
		nl: nl.route_details__costs_section__tolls_list,
		pt: pt.route_details__costs_section__tolls_list
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__total_cost = (params = {}, options = {}) => {
	return {
		de: de.route_details__costs_section__total_cost,
		en: en.route_details__costs_section__total_cost,
		es: es.route_details__costs_section__total_cost,
		fr: fr.route_details__costs_section__total_cost,
		it: it.route_details__costs_section__total_cost,
		nl: nl.route_details__costs_section__total_cost,
		pt: pt.route_details__costs_section__total_cost
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__vignette = (params = {}, options = {}) => {
	return {
		de: de.route_details__costs_section__vignette,
		en: en.route_details__costs_section__vignette,
		es: es.route_details__costs_section__vignette,
		fr: fr.route_details__costs_section__vignette,
		it: it.route_details__costs_section__vignette,
		nl: nl.route_details__costs_section__vignette,
		pt: pt.route_details__costs_section__vignette
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note,
		en: en.route_details__expense_note,
		es: es.route_details__expense_note,
		fr: fr.route_details__expense_note,
		it: it.route_details__expense_note,
		nl: nl.route_details__expense_note,
		pt: pt.route_details__expense_note
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__allowance = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__allowance,
		en: en.route_details__expense_note_section__allowance,
		es: es.route_details__expense_note_section__allowance,
		fr: fr.route_details__expense_note_section__allowance,
		it: it.route_details__expense_note_section__allowance,
		nl: nl.route_details__expense_note_section__allowance,
		pt: pt.route_details__expense_note_section__allowance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__arrival = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__arrival,
		en: en.route_details__expense_note_section__arrival,
		es: es.route_details__expense_note_section__arrival,
		fr: fr.route_details__expense_note_section__arrival,
		it: it.route_details__expense_note_section__arrival,
		nl: nl.route_details__expense_note_section__arrival,
		pt: pt.route_details__expense_note_section__arrival
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__back = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__back,
		en: en.route_details__expense_note_section__back,
		es: es.route_details__expense_note_section__back,
		fr: fr.route_details__expense_note_section__back,
		it: it.route_details__expense_note_section__back,
		nl: nl.route_details__expense_note_section__back,
		pt: pt.route_details__expense_note_section__back
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__costs = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__costs,
		en: en.route_details__expense_note_section__costs,
		es: es.route_details__expense_note_section__costs,
		fr: fr.route_details__expense_note_section__costs,
		it: it.route_details__expense_note_section__costs,
		nl: nl.route_details__expense_note_section__costs,
		pt: pt.route_details__expense_note_section__costs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__date = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__date,
		en: en.route_details__expense_note_section__date,
		es: es.route_details__expense_note_section__date,
		fr: fr.route_details__expense_note_section__date,
		it: it.route_details__expense_note_section__date,
		nl: nl.route_details__expense_note_section__date,
		pt: pt.route_details__expense_note_section__date
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__departure = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__departure,
		en: en.route_details__expense_note_section__departure,
		es: es.route_details__expense_note_section__departure,
		fr: fr.route_details__expense_note_section__departure,
		it: it.route_details__expense_note_section__departure,
		nl: nl.route_details__expense_note_section__departure,
		pt: pt.route_details__expense_note_section__departure
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__distance = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__distance,
		en: en.route_details__expense_note_section__distance,
		es: es.route_details__expense_note_section__distance,
		fr: fr.route_details__expense_note_section__distance,
		it: it.route_details__expense_note_section__distance,
		nl: nl.route_details__expense_note_section__distance,
		pt: pt.route_details__expense_note_section__distance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__additional_data,
		en: en.route_details__expense_note_section__edit__additional_data,
		es: es.route_details__expense_note_section__edit__additional_data,
		fr: fr.route_details__expense_note_section__edit__additional_data,
		it: it.route_details__expense_note_section__edit__additional_data,
		nl: nl.route_details__expense_note_section__edit__additional_data,
		pt: pt.route_details__expense_note_section__edit__additional_data
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data_placeholder = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__additional_data_placeholder,
		en: en.route_details__expense_note_section__edit__additional_data_placeholder,
		es: es.route_details__expense_note_section__edit__additional_data_placeholder,
		fr: fr.route_details__expense_note_section__edit__additional_data_placeholder,
		it: it.route_details__expense_note_section__edit__additional_data_placeholder,
		nl: nl.route_details__expense_note_section__edit__additional_data_placeholder,
		pt: pt.route_details__expense_note_section__edit__additional_data_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__allowance = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__allowance,
		en: en.route_details__expense_note_section__edit__allowance,
		es: es.route_details__expense_note_section__edit__allowance,
		fr: fr.route_details__expense_note_section__edit__allowance,
		it: it.route_details__expense_note_section__edit__allowance,
		nl: nl.route_details__expense_note_section__edit__allowance,
		pt: pt.route_details__expense_note_section__edit__allowance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__allowance_input = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__allowance_input,
		en: en.route_details__expense_note_section__edit__allowance_input,
		es: es.route_details__expense_note_section__edit__allowance_input,
		fr: fr.route_details__expense_note_section__edit__allowance_input,
		it: it.route_details__expense_note_section__edit__allowance_input,
		nl: nl.route_details__expense_note_section__edit__allowance_input,
		pt: pt.route_details__expense_note_section__edit__allowance_input
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__compute_method = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__compute_method,
		en: en.route_details__expense_note_section__edit__compute_method,
		es: es.route_details__expense_note_section__edit__compute_method,
		fr: fr.route_details__expense_note_section__edit__compute_method,
		it: it.route_details__expense_note_section__edit__compute_method,
		nl: nl.route_details__expense_note_section__edit__compute_method,
		pt: pt.route_details__expense_note_section__edit__compute_method
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__electricity = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__electricity,
		en: en.route_details__expense_note_section__edit__electricity,
		es: es.route_details__expense_note_section__edit__electricity,
		fr: fr.route_details__expense_note_section__edit__electricity,
		it: it.route_details__expense_note_section__edit__electricity,
		nl: nl.route_details__expense_note_section__edit__electricity,
		pt: pt.route_details__expense_note_section__edit__electricity
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__fuel = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__fuel,
		en: en.route_details__expense_note_section__edit__fuel,
		es: es.route_details__expense_note_section__edit__fuel,
		fr: fr.route_details__expense_note_section__edit__fuel,
		it: it.route_details__expense_note_section__edit__fuel,
		nl: nl.route_details__expense_note_section__edit__fuel,
		pt: pt.route_details__expense_note_section__edit__fuel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__identity = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__identity,
		en: en.route_details__expense_note_section__edit__identity,
		es: es.route_details__expense_note_section__edit__identity,
		fr: fr.route_details__expense_note_section__edit__identity,
		it: it.route_details__expense_note_section__edit__identity,
		nl: nl.route_details__expense_note_section__edit__identity,
		pt: pt.route_details__expense_note_section__edit__identity
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__identity_placeholder = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__identity_placeholder,
		en: en.route_details__expense_note_section__edit__identity_placeholder,
		es: es.route_details__expense_note_section__edit__identity_placeholder,
		fr: fr.route_details__expense_note_section__edit__identity_placeholder,
		it: it.route_details__expense_note_section__edit__identity_placeholder,
		nl: nl.route_details__expense_note_section__edit__identity_placeholder,
		pt: pt.route_details__expense_note_section__edit__identity_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__include = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__include,
		en: en.route_details__expense_note_section__edit__include,
		es: es.route_details__expense_note_section__edit__include,
		fr: fr.route_details__expense_note_section__edit__include,
		it: it.route_details__expense_note_section__edit__include,
		nl: nl.route_details__expense_note_section__edit__include,
		pt: pt.route_details__expense_note_section__edit__include
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__legal_info = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__legal_info,
		en: en.route_details__expense_note_section__edit__legal_info,
		es: es.route_details__expense_note_section__edit__legal_info,
		fr: fr.route_details__expense_note_section__edit__legal_info,
		it: it.route_details__expense_note_section__edit__legal_info,
		nl: nl.route_details__expense_note_section__edit__legal_info,
		pt: pt.route_details__expense_note_section__edit__legal_info
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__real = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__real,
		en: en.route_details__expense_note_section__edit__real,
		es: es.route_details__expense_note_section__edit__real,
		fr: fr.route_details__expense_note_section__edit__real,
		it: it.route_details__expense_note_section__edit__real,
		nl: nl.route_details__expense_note_section__edit__real,
		pt: pt.route_details__expense_note_section__edit__real
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__title = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__title,
		en: en.route_details__expense_note_section__edit__title,
		es: es.route_details__expense_note_section__edit__title,
		fr: fr.route_details__expense_note_section__edit__title,
		it: it.route_details__expense_note_section__edit__title,
		nl: nl.route_details__expense_note_section__edit__title,
		pt: pt.route_details__expense_note_section__edit__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__travel_date = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__edit__travel_date,
		en: en.route_details__expense_note_section__edit__travel_date,
		es: es.route_details__expense_note_section__edit__travel_date,
		fr: fr.route_details__expense_note_section__edit__travel_date,
		it: it.route_details__expense_note_section__edit__travel_date,
		nl: nl.route_details__expense_note_section__edit__travel_date,
		pt: pt.route_details__expense_note_section__edit__travel_date
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__electricity = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__electricity,
		en: en.route_details__expense_note_section__electricity,
		es: es.route_details__expense_note_section__electricity,
		fr: fr.route_details__expense_note_section__electricity,
		it: it.route_details__expense_note_section__electricity,
		nl: nl.route_details__expense_note_section__electricity,
		pt: pt.route_details__expense_note_section__electricity
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__fuel = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__fuel,
		en: en.route_details__expense_note_section__fuel,
		es: es.route_details__expense_note_section__fuel,
		fr: fr.route_details__expense_note_section__fuel,
		it: it.route_details__expense_note_section__fuel,
		nl: nl.route_details__expense_note_section__fuel,
		pt: pt.route_details__expense_note_section__fuel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ date: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__generated_on = (params , options = {}) => {
	return {
		de: de.route_details__expense_note_section__generated_on,
		en: en.route_details__expense_note_section__generated_on,
		es: es.route_details__expense_note_section__generated_on,
		fr: fr.route_details__expense_note_section__generated_on,
		it: it.route_details__expense_note_section__generated_on,
		nl: nl.route_details__expense_note_section__generated_on,
		pt: pt.route_details__expense_note_section__generated_on
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__identity = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__identity,
		en: en.route_details__expense_note_section__identity,
		es: es.route_details__expense_note_section__identity,
		fr: fr.route_details__expense_note_section__identity,
		it: it.route_details__expense_note_section__identity,
		nl: nl.route_details__expense_note_section__identity,
		pt: pt.route_details__expense_note_section__identity
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__notes = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__notes,
		en: en.route_details__expense_note_section__notes,
		es: es.route_details__expense_note_section__notes,
		fr: fr.route_details__expense_note_section__notes,
		it: it.route_details__expense_note_section__notes,
		nl: nl.route_details__expense_note_section__notes,
		pt: pt.route_details__expense_note_section__notes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__tolls = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__tolls,
		en: en.route_details__expense_note_section__tolls,
		es: es.route_details__expense_note_section__tolls,
		fr: fr.route_details__expense_note_section__tolls,
		it: it.route_details__expense_note_section__tolls,
		nl: nl.route_details__expense_note_section__tolls,
		pt: pt.route_details__expense_note_section__tolls
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__total = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__total,
		en: en.route_details__expense_note_section__total,
		es: es.route_details__expense_note_section__total,
		fr: fr.route_details__expense_note_section__total,
		it: it.route_details__expense_note_section__total,
		nl: nl.route_details__expense_note_section__total,
		pt: pt.route_details__expense_note_section__total
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__travel = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__travel,
		en: en.route_details__expense_note_section__travel,
		es: es.route_details__expense_note_section__travel,
		fr: fr.route_details__expense_note_section__travel,
		it: it.route_details__expense_note_section__travel,
		nl: nl.route_details__expense_note_section__travel,
		pt: pt.route_details__expense_note_section__travel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__vignette = (params = {}, options = {}) => {
	return {
		de: de.route_details__expense_note_section__vignette,
		en: en.route_details__expense_note_section__vignette,
		es: es.route_details__expense_note_section__vignette,
		fr: fr.route_details__expense_note_section__vignette,
		it: it.route_details__expense_note_section__vignette,
		nl: nl.route_details__expense_note_section__vignette,
		pt: pt.route_details__expense_note_section__vignette
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__instructions = (params = {}, options = {}) => {
	return {
		de: de.route_details__instructions,
		en: en.route_details__instructions,
		es: es.route_details__instructions,
		fr: fr.route_details__instructions,
		it: it.route_details__instructions,
		nl: nl.route_details__instructions,
		pt: pt.route_details__instructions
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__instructions__error = (params = {}, options = {}) => {
	return {
		de: de.route_details__instructions__error,
		en: en.route_details__instructions__error,
		es: es.route_details__instructions__error,
		fr: fr.route_details__instructions__error,
		it: it.route_details__instructions__error,
		nl: nl.route_details__instructions__error,
		pt: pt.route_details__instructions__error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way = (params = {}, options = {}) => {
	return {
		de: de.route_details__on_the_way,
		en: en.route_details__on_the_way,
		es: es.route_details__on_the_way,
		fr: fr.route_details__on_the_way,
		it: it.route_details__on_the_way,
		nl: nl.route_details__on_the_way,
		pt: pt.route_details__on_the_way
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__detour = (params = {}, options = {}) => {
	return {
		de: de.route_details__on_the_way_section__filters__detour,
		en: en.route_details__on_the_way_section__filters__detour,
		es: es.route_details__on_the_way_section__filters__detour,
		fr: fr.route_details__on_the_way_section__filters__detour,
		it: it.route_details__on_the_way_section__filters__detour,
		nl: nl.route_details__on_the_way_section__filters__detour,
		pt: pt.route_details__on_the_way_section__filters__detour
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__infos = (params = {}, options = {}) => {
	return {
		de: de.route_details__on_the_way_section__filters__infos,
		en: en.route_details__on_the_way_section__filters__infos,
		es: es.route_details__on_the_way_section__filters__infos,
		fr: fr.route_details__on_the_way_section__filters__infos,
		it: it.route_details__on_the_way_section__filters__infos,
		nl: nl.route_details__on_the_way_section__filters__infos,
		pt: pt.route_details__on_the_way_section__filters__infos
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__scope = (params = {}, options = {}) => {
	return {
		de: de.route_details__on_the_way_section__filters__scope,
		en: en.route_details__on_the_way_section__filters__scope,
		es: es.route_details__on_the_way_section__filters__scope,
		fr: fr.route_details__on_the_way_section__filters__scope,
		it: it.route_details__on_the_way_section__filters__scope,
		nl: nl.route_details__on_the_way_section__filters__scope,
		pt: pt.route_details__on_the_way_section__filters__scope
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ value: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__up_to = (params , options = {}) => {
	return {
		de: de.route_details__on_the_way_section__filters__up_to,
		en: en.route_details__on_the_way_section__filters__up_to,
		es: es.route_details__on_the_way_section__filters__up_to,
		fr: fr.route_details__on_the_way_section__filters__up_to,
		it: it.route_details__on_the_way_section__filters__up_to,
		nl: nl.route_details__on_the_way_section__filters__up_to,
		pt: pt.route_details__on_the_way_section__filters__up_to
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__recommendations = (params = {}, options = {}) => {
	return {
		de: de.route_details__recommendations,
		en: en.route_details__recommendations,
		es: es.route_details__recommendations,
		fr: fr.route_details__recommendations,
		it: it.route_details__recommendations,
		nl: nl.route_details__recommendations,
		pt: pt.route_details__recommendations
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__cta = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__blablacar__cta,
		en: en.route_spec_card__blablacar__cta,
		es: es.route_spec_card__blablacar__cta,
		fr: fr.route_spec_card__blablacar__cta,
		it: it.route_spec_card__blablacar__cta,
		nl: nl.route_spec_card__blablacar__cta,
		pt: pt.route_spec_card__blablacar__cta
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__description = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__blablacar__description,
		en: en.route_spec_card__blablacar__description,
		es: es.route_spec_card__blablacar__description,
		fr: fr.route_spec_card__blablacar__description,
		it: it.route_spec_card__blablacar__description,
		nl: nl.route_spec_card__blablacar__description,
		pt: pt.route_spec_card__blablacar__description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__subtitle = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__blablacar__subtitle,
		en: en.route_spec_card__blablacar__subtitle,
		es: es.route_spec_card__blablacar__subtitle,
		fr: fr.route_spec_card__blablacar__subtitle,
		it: it.route_spec_card__blablacar__subtitle,
		nl: nl.route_spec_card__blablacar__subtitle,
		pt: pt.route_spec_card__blablacar__subtitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__title = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__blablacar__title,
		en: en.route_spec_card__blablacar__title,
		es: es.route_spec_card__blablacar__title,
		fr: fr.route_spec_card__blablacar__title,
		it: it.route_spec_card__blablacar__title,
		nl: nl.route_spec_card__blablacar__title,
		pt: pt.route_spec_card__blablacar__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__button_label = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__detailed_costs__button_label,
		en: en.route_spec_card__detailed_costs__button_label,
		es: es.route_spec_card__detailed_costs__button_label,
		fr: fr.route_spec_card__detailed_costs__button_label,
		it: it.route_spec_card__detailed_costs__button_label,
		nl: nl.route_spec_card__detailed_costs__button_label,
		pt: pt.route_spec_card__detailed_costs__button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__ev_charging = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__detailed_costs__ev_charging,
		en: en.route_spec_card__detailed_costs__ev_charging,
		es: es.route_spec_card__detailed_costs__ev_charging,
		fr: fr.route_spec_card__detailed_costs__ev_charging,
		it: it.route_spec_card__detailed_costs__ev_charging,
		nl: nl.route_spec_card__detailed_costs__ev_charging,
		pt: pt.route_spec_card__detailed_costs__ev_charging
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__fuel = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__detailed_costs__fuel,
		en: en.route_spec_card__detailed_costs__fuel,
		es: es.route_spec_card__detailed_costs__fuel,
		fr: fr.route_spec_card__detailed_costs__fuel,
		it: it.route_spec_card__detailed_costs__fuel,
		nl: nl.route_spec_card__detailed_costs__fuel,
		pt: pt.route_spec_card__detailed_costs__fuel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__title = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__detailed_costs__title,
		en: en.route_spec_card__detailed_costs__title,
		es: es.route_spec_card__detailed_costs__title,
		fr: fr.route_spec_card__detailed_costs__title,
		it: it.route_spec_card__detailed_costs__title,
		nl: nl.route_spec_card__detailed_costs__title,
		pt: pt.route_spec_card__detailed_costs__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__tolls = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__detailed_costs__tolls,
		en: en.route_spec_card__detailed_costs__tolls,
		es: es.route_spec_card__detailed_costs__tolls,
		fr: fr.route_spec_card__detailed_costs__tolls,
		it: it.route_spec_card__detailed_costs__tolls,
		nl: nl.route_spec_card__detailed_costs__tolls,
		pt: pt.route_spec_card__detailed_costs__tolls
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__on_the_road__title = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__on_the_road__title,
		en: en.route_spec_card__on_the_road__title,
		es: es.route_spec_card__on_the_road__title,
		fr: fr.route_spec_card__on_the_road__title,
		it: it.route_spec_card__on_the_road__title,
		nl: nl.route_spec_card__on_the_road__title,
		pt: pt.route_spec_card__on_the_road__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__rest_stop__button_label = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__rest_stop__button_label,
		en: en.route_spec_card__rest_stop__button_label,
		es: es.route_spec_card__rest_stop__button_label,
		fr: fr.route_spec_card__rest_stop__button_label,
		it: it.route_spec_card__rest_stop__button_label,
		nl: nl.route_spec_card__rest_stop__button_label,
		pt: pt.route_spec_card__rest_stop__button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__button_label = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__roadsheet__button_label,
		en: en.route_spec_card__roadsheet__button_label,
		es: es.route_spec_card__roadsheet__button_label,
		fr: fr.route_spec_card__roadsheet__button_label,
		it: it.route_spec_card__roadsheet__button_label,
		nl: nl.route_spec_card__roadsheet__button_label,
		pt: pt.route_spec_card__roadsheet__button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__emissions = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__roadsheet__emissions,
		en: en.route_spec_card__roadsheet__emissions,
		es: es.route_spec_card__roadsheet__emissions,
		fr: fr.route_spec_card__roadsheet__emissions,
		it: it.route_spec_card__roadsheet__emissions,
		nl: nl.route_spec_card__roadsheet__emissions,
		pt: pt.route_spec_card__roadsheet__emissions
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__ev_charging = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__roadsheet__ev_charging,
		en: en.route_spec_card__roadsheet__ev_charging,
		es: es.route_spec_card__roadsheet__ev_charging,
		fr: fr.route_spec_card__roadsheet__ev_charging,
		it: it.route_spec_card__roadsheet__ev_charging,
		nl: nl.route_spec_card__roadsheet__ev_charging,
		pt: pt.route_spec_card__roadsheet__ev_charging
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__highway = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__roadsheet__highway,
		en: en.route_spec_card__roadsheet__highway,
		es: es.route_spec_card__roadsheet__highway,
		fr: fr.route_spec_card__roadsheet__highway,
		it: it.route_spec_card__roadsheet__highway,
		nl: nl.route_spec_card__roadsheet__highway,
		pt: pt.route_spec_card__roadsheet__highway
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__title = (params = {}, options = {}) => {
	return {
		de: de.route_spec_card__roadsheet__title,
		en: en.route_spec_card__roadsheet__title,
		es: es.route_spec_card__roadsheet__title,
		fr: fr.route_spec_card__roadsheet__title,
		it: it.route_spec_card__roadsheet__title,
		nl: nl.route_spec_card__roadsheet__title,
		pt: pt.route_spec_card__roadsheet__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__cta_label = (params = {}, options = {}) => {
	return {
		de: de.route_zoi_hotel__cta_label,
		en: en.route_zoi_hotel__cta_label,
		es: es.route_zoi_hotel__cta_label,
		fr: fr.route_zoi_hotel__cta_label,
		it: it.route_zoi_hotel__cta_label,
		nl: nl.route_zoi_hotel__cta_label,
		pt: pt.route_zoi_hotel__cta_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__title = (params = {}, options = {}) => {
	return {
		de: de.route_zoi_hotel__title,
		en: en.route_zoi_hotel__title,
		es: es.route_zoi_hotel__title,
		fr: fr.route_zoi_hotel__title,
		it: it.route_zoi_hotel__title,
		nl: nl.route_zoi_hotel__title,
		pt: pt.route_zoi_hotel__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__cta_label = (params = {}, options = {}) => {
	return {
		de: de.routecosts__blablacar_card__cta_label,
		en: en.routecosts__blablacar_card__cta_label,
		es: es.routecosts__blablacar_card__cta_label,
		fr: fr.routecosts__blablacar_card__cta_label,
		it: it.routecosts__blablacar_card__cta_label,
		nl: nl.routecosts__blablacar_card__cta_label,
		pt: pt.routecosts__blablacar_card__cta_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ device: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__cta_url = (params , options = {}) => {
	return {
		de: de.routecosts__blablacar_card__cta_url,
		en: en.routecosts__blablacar_card__cta_url,
		es: es.routecosts__blablacar_card__cta_url,
		fr: fr.routecosts__blablacar_card__cta_url,
		it: it.routecosts__blablacar_card__cta_url,
		nl: nl.routecosts__blablacar_card__cta_url,
		pt: pt.routecosts__blablacar_card__cta_url
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__description = (params = {}, options = {}) => {
	return {
		de: de.routecosts__blablacar_card__description,
		en: en.routecosts__blablacar_card__description,
		es: es.routecosts__blablacar_card__description,
		fr: fr.routecosts__blablacar_card__description,
		it: it.routecosts__blablacar_card__description,
		nl: nl.routecosts__blablacar_card__description,
		pt: pt.routecosts__blablacar_card__description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__legal_notice = (params = {}, options = {}) => {
	return {
		de: de.routecosts__blablacar_card__legal_notice,
		en: en.routecosts__blablacar_card__legal_notice,
		es: es.routecosts__blablacar_card__legal_notice,
		fr: fr.routecosts__blablacar_card__legal_notice,
		it: it.routecosts__blablacar_card__legal_notice,
		nl: nl.routecosts__blablacar_card__legal_notice,
		pt: pt.routecosts__blablacar_card__legal_notice
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__title = (params = {}, options = {}) => {
	return {
		de: de.routecosts__blablacar_card__title,
		en: en.routecosts__blablacar_card__title,
		es: es.routecosts__blablacar_card__title,
		fr: fr.routecosts__blablacar_card__title,
		it: it.routecosts__blablacar_card__title,
		nl: nl.routecosts__blablacar_card__title,
		pt: pt.routecosts__blablacar_card__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__cta_label = (params = {}, options = {}) => {
	return {
		de: de.routeresults__blablacar_card__cta_label,
		en: en.routeresults__blablacar_card__cta_label,
		es: es.routeresults__blablacar_card__cta_label,
		fr: fr.routeresults__blablacar_card__cta_label,
		it: it.routeresults__blablacar_card__cta_label,
		nl: nl.routeresults__blablacar_card__cta_label,
		pt: pt.routeresults__blablacar_card__cta_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ departure: NonNullable<unknown>, arrival: NonNullable<unknown>, device: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__cta_url = (params , options = {}) => {
	return {
		de: de.routeresults__blablacar_card__cta_url,
		en: en.routeresults__blablacar_card__cta_url,
		es: es.routeresults__blablacar_card__cta_url,
		fr: fr.routeresults__blablacar_card__cta_url,
		it: it.routeresults__blablacar_card__cta_url,
		nl: nl.routeresults__blablacar_card__cta_url,
		pt: pt.routeresults__blablacar_card__cta_url
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ cost: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__description = (params , options = {}) => {
	return {
		de: de.routeresults__blablacar_card__description,
		en: en.routeresults__blablacar_card__description,
		es: es.routeresults__blablacar_card__description,
		fr: fr.routeresults__blablacar_card__description,
		it: it.routeresults__blablacar_card__description,
		nl: nl.routeresults__blablacar_card__description,
		pt: pt.routeresults__blablacar_card__description
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__legal_notice = (params = {}, options = {}) => {
	return {
		de: de.routeresults__blablacar_card__legal_notice,
		en: en.routeresults__blablacar_card__legal_notice,
		es: es.routeresults__blablacar_card__legal_notice,
		fr: fr.routeresults__blablacar_card__legal_notice,
		it: it.routeresults__blablacar_card__legal_notice,
		nl: nl.routeresults__blablacar_card__legal_notice,
		pt: pt.routeresults__blablacar_card__legal_notice
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ departure: NonNullable<unknown>, arrival: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__title = (params , options = {}) => {
	return {
		de: de.routeresults__blablacar_card__title,
		en: en.routeresults__blablacar_card__title,
		es: es.routeresults__blablacar_card__title,
		fr: fr.routeresults__blablacar_card__title,
		it: it.routeresults__blablacar_card__title,
		nl: nl.routeresults__blablacar_card__title,
		pt: pt.routeresults__blablacar_card__title
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search__input__aria_label = (params = {}, options = {}) => {
	return {
		de: de.search__input__aria_label,
		en: en.search__input__aria_label,
		es: es.search__input__aria_label,
		fr: fr.search__input__aria_label,
		it: it.search__input__aria_label,
		nl: nl.search__input__aria_label,
		pt: pt.search__input__aria_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__button__aria_label = (params = {}, options = {}) => {
	return {
		de: de.search_tools__button__aria_label,
		en: en.search_tools__button__aria_label,
		es: es.search_tools__button__aria_label,
		fr: fr.search_tools__button__aria_label,
		it: it.search_tools__button__aria_label,
		nl: nl.search_tools__button__aria_label,
		pt: pt.search_tools__button__aria_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__button__text = (params = {}, options = {}) => {
	return {
		de: de.search_tools__button__text,
		en: en.search_tools__button__text,
		es: es.search_tools__button__text,
		fr: fr.search_tools__button__text,
		it: it.search_tools__button__text,
		nl: nl.search_tools__button__text,
		pt: pt.search_tools__button__text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__empty = (params = {}, options = {}) => {
	return {
		de: de.search_tools__messages__empty,
		en: en.search_tools__messages__empty,
		es: es.search_tools__messages__empty,
		fr: fr.search_tools__messages__empty,
		it: it.search_tools__messages__empty,
		nl: nl.search_tools__messages__empty,
		pt: pt.search_tools__messages__empty
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__error = (params = {}, options = {}) => {
	return {
		de: de.search_tools__messages__error,
		en: en.search_tools__messages__error,
		es: es.search_tools__messages__error,
		fr: fr.search_tools__messages__error,
		it: it.search_tools__messages__error,
		nl: nl.search_tools__messages__error,
		pt: pt.search_tools__messages__error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__image_alt = (params = {}, options = {}) => {
	return {
		de: de.search_tools__messages__image_alt,
		en: en.search_tools__messages__image_alt,
		es: es.search_tools__messages__image_alt,
		fr: fr.search_tools__messages__image_alt,
		it: it.search_tools__messages__image_alt,
		nl: nl.search_tools__messages__image_alt,
		pt: pt.search_tools__messages__image_alt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__results__aria_label = (params = {}, options = {}) => {
	return {
		de: de.search_tools__results__aria_label,
		en: en.search_tools__results__aria_label,
		es: es.search_tools__results__aria_label,
		fr: fr.search_tools__results__aria_label,
		it: it.search_tools__results__aria_label,
		nl: nl.search_tools__results__aria_label,
		pt: pt.search_tools__results__aria_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const settings__close = (params = {}, options = {}) => {
	return {
		de: de.settings__close,
		en: en.settings__close,
		es: es.settings__close,
		fr: fr.settings__close,
		it: it.settings__close,
		nl: nl.settings__close,
		pt: pt.settings__close
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__close_button = (params = {}, options = {}) => {
	return {
		de: de.sf_logout__close_button,
		en: en.sf_logout__close_button,
		es: es.sf_logout__close_button,
		fr: fr.sf_logout__close_button,
		it: it.sf_logout__close_button,
		nl: nl.sf_logout__close_button,
		pt: pt.sf_logout__close_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__loading = (params = {}, options = {}) => {
	return {
		de: de.sf_logout__loading,
		en: en.sf_logout__loading,
		es: es.sf_logout__loading,
		fr: fr.sf_logout__loading,
		it: it.sf_logout__loading,
		nl: nl.sf_logout__loading,
		pt: pt.sf_logout__loading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__logged_out = (params = {}, options = {}) => {
	return {
		de: de.sf_logout__logged_out,
		en: en.sf_logout__logged_out,
		es: es.sf_logout__logged_out,
		fr: fr.sf_logout__logged_out,
		it: it.sf_logout__logged_out,
		nl: nl.sf_logout__logged_out,
		pt: pt.sf_logout__logged_out
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const soon = (params = {}, options = {}) => {
	return {
		de: de.soon,
		en: en.soon,
		es: es.soon,
		fr: fr.soon,
		it: it.soon,
		nl: nl.soon,
		pt: pt.soon
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_deviation__cta = (params = {}, options = {}) => {
	return {
		de: de.traffic_deviation__cta,
		en: en.traffic_deviation__cta,
		es: es.traffic_deviation__cta,
		fr: fr.traffic_deviation__cta,
		it: it.traffic_deviation__cta,
		nl: nl.traffic_deviation__cta,
		pt: pt.traffic_deviation__cta
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_accident = (params = {}, options = {}) => {
	return {
		de: de.traffic_event__car_accident,
		en: en.traffic_event__car_accident,
		es: es.traffic_event__car_accident,
		fr: fr.traffic_event__car_accident,
		it: it.traffic_event__car_accident,
		nl: nl.traffic_event__car_accident,
		pt: pt.traffic_event__car_accident
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_dangerous = (params = {}, options = {}) => {
	return {
		de: de.traffic_event__car_dangerous,
		en: en.traffic_event__car_dangerous,
		es: es.traffic_event__car_dangerous,
		fr: fr.traffic_event__car_dangerous,
		it: it.traffic_event__car_dangerous,
		nl: nl.traffic_event__car_dangerous,
		pt: pt.traffic_event__car_dangerous
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_incident = (params = {}, options = {}) => {
	return {
		de: de.traffic_event__car_incident,
		en: en.traffic_event__car_incident,
		es: es.traffic_event__car_incident,
		fr: fr.traffic_event__car_incident,
		it: it.traffic_event__car_incident,
		nl: nl.traffic_event__car_incident,
		pt: pt.traffic_event__car_incident
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__construction_cone = (params = {}, options = {}) => {
	return {
		de: de.traffic_event__construction_cone,
		en: en.traffic_event__construction_cone,
		es: es.traffic_event__construction_cone,
		fr: fr.traffic_event__construction_cone,
		it: it.traffic_event__construction_cone,
		nl: nl.traffic_event__construction_cone,
		pt: pt.traffic_event__construction_cone
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__lane_closed = (params = {}, options = {}) => {
	return {
		de: de.traffic_event__lane_closed,
		en: en.traffic_event__lane_closed,
		es: es.traffic_event__lane_closed,
		fr: fr.traffic_event__lane_closed,
		it: it.traffic_event__lane_closed,
		nl: nl.traffic_event__lane_closed,
		pt: pt.traffic_event__lane_closed
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__weather_hail = (params = {}, options = {}) => {
	return {
		de: de.traffic_event__weather_hail,
		en: en.traffic_event__weather_hail,
		es: es.traffic_event__weather_hail,
		fr: fr.traffic_event__weather_hail,
		it: it.traffic_event__weather_hail,
		nl: nl.traffic_event__weather_hail,
		pt: pt.traffic_event__weather_hail
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_info_settings__header = (params = {}, options = {}) => {
	return {
		de: de.traffic_info_settings__header,
		en: en.traffic_info_settings__header,
		es: es.traffic_info_settings__header,
		fr: fr.traffic_info_settings__header,
		it: it.traffic_info_settings__header,
		nl: nl.traffic_info_settings__header,
		pt: pt.traffic_info_settings__header
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__go_to_partner_website = (params = {}, options = {}) => {
	return {
		de: de.view_more__go_to_partner_website,
		en: en.view_more__go_to_partner_website,
		es: es.view_more__go_to_partner_website,
		fr: fr.view_more__go_to_partner_website,
		it: it.view_more__go_to_partner_website,
		nl: nl.view_more__go_to_partner_website,
		pt: pt.view_more__go_to_partner_website
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__no_room = (params = {}, options = {}) => {
	return {
		de: de.view_more__no_room,
		en: en.view_more__no_room,
		es: es.view_more__no_room,
		fr: fr.view_more__no_room,
		it: it.view_more__no_room,
		nl: nl.view_more__no_room,
		pt: pt.view_more__no_room
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__on = (params = {}, options = {}) => {
	return {
		de: de.view_more__on,
		en: en.view_more__on,
		es: es.view_more__on,
		fr: fr.view_more__on,
		it: it.view_more__on,
		nl: nl.view_more__on,
		pt: pt.view_more__on
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__on_partner_website = (params = {}, options = {}) => {
	return {
		de: de.view_more__on_partner_website,
		en: en.view_more__on_partner_website,
		es: es.view_more__on_partner_website,
		fr: fr.view_more__on_partner_website,
		it: it.view_more__on_partner_website,
		nl: nl.view_more__on_partner_website,
		pt: pt.view_more__on_partner_website
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__ev_only = (params = {}, options = {}) => {
	return {
		de: de.zoi__filters__ev_only,
		en: en.zoi__filters__ev_only,
		es: es.zoi__filters__ev_only,
		fr: fr.zoi__filters__ev_only,
		it: it.zoi__filters__ev_only,
		nl: nl.zoi__filters__ev_only,
		pt: pt.zoi__filters__ev_only
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range = (params = {}, options = {}) => {
	return {
		de: de.zoi__filters__search_range,
		en: en.zoi__filters__search_range,
		es: es.zoi__filters__search_range,
		fr: fr.zoi__filters__search_range,
		it: it.zoi__filters__search_range,
		nl: nl.zoi__filters__search_range,
		pt: pt.zoi__filters__search_range
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range__text = (params = {}, options = {}) => {
	return {
		de: de.zoi__filters__search_range__text,
		en: en.zoi__filters__search_range__text,
		es: es.zoi__filters__search_range__text,
		fr: fr.zoi__filters__search_range__text,
		it: it.zoi__filters__search_range__text,
		nl: nl.zoi__filters__search_range__text,
		pt: pt.zoi__filters__search_range__text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ value: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range__value = (params , options = {}) => {
	return {
		de: de.zoi__filters__search_range__value,
		en: en.zoi__filters__search_range__value,
		es: es.zoi__filters__search_range__value,
		fr: fr.zoi__filters__search_range__value,
		it: it.zoi__filters__search_range__value,
		nl: nl.zoi__filters__search_range__value,
		pt: pt.zoi__filters__search_range__value
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__notToBeMissed = (params = {}, options = {}) => {
	return {
		de: de.zoi__notToBeMissed,
		en: en.zoi__notToBeMissed,
		es: es.zoi__notToBeMissed,
		fr: fr.zoi__notToBeMissed,
		it: it.zoi__notToBeMissed,
		nl: nl.zoi__notToBeMissed,
		pt: pt.zoi__notToBeMissed
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois__see_all = (params = {}, options = {}) => {
	return {
		de: de.zoi__pois__see_all,
		en: en.zoi__pois__see_all,
		es: es.zoi__pois__see_all,
		fr: fr.zoi__pois__see_all,
		it: it.zoi__pois__see_all,
		nl: nl.zoi__pois__see_all,
		pt: pt.zoi__pois__see_all
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_subtitle = (params = {}, options = {}) => {
	return {
		de: de.zoi__pois_subtitle,
		en: en.zoi__pois_subtitle,
		es: es.zoi__pois_subtitle,
		fr: fr.zoi__pois_subtitle,
		it: it.zoi__pois_subtitle,
		nl: nl.zoi__pois_subtitle,
		pt: pt.zoi__pois_subtitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_title = (params = {}, options = {}) => {
	return {
		de: de.zoi__pois_title,
		en: en.zoi__pois_title,
		es: es.zoi__pois_title,
		fr: fr.zoi__pois_title,
		it: it.zoi__pois_title,
		nl: nl.zoi__pois_title,
		pt: pt.zoi__pois_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__title = (params = {}, options = {}) => {
	return {
		de: de.zoi__title,
		en: en.zoi__title,
		es: es.zoi__title,
		fr: fr.zoi__title,
		it: it.zoi__title,
		nl: nl.zoi__title,
		pt: pt.zoi__title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__available_accommodation = (params = {}, options = {}) => {
	return {
		de: de.zoi_card__arrival__available_accommodation,
		en: en.zoi_card__arrival__available_accommodation,
		es: es.zoi_card__arrival__available_accommodation,
		fr: fr.zoi_card__arrival__available_accommodation,
		it: it.zoi_card__arrival__available_accommodation,
		nl: nl.zoi_card__arrival__available_accommodation,
		pt: pt.zoi_card__arrival__available_accommodation
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__see_accommodation_zone = (params = {}, options = {}) => {
	return {
		de: de.zoi_card__arrival__see_accommodation_zone,
		en: en.zoi_card__arrival__see_accommodation_zone,
		es: es.zoi_card__arrival__see_accommodation_zone,
		fr: fr.zoi_card__arrival__see_accommodation_zone,
		it: it.zoi_card__arrival__see_accommodation_zone,
		nl: nl.zoi_card__arrival__see_accommodation_zone,
		pt: pt.zoi_card__arrival__see_accommodation_zone
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__error = (params = {}, options = {}) => {
	return {
		de: de.zoi_card__error,
		en: en.zoi_card__error,
		es: es.zoi_card__error,
		fr: fr.zoi_card__error,
		it: it.zoi_card__error,
		nl: nl.zoi_card__error,
		pt: pt.zoi_card__error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__image_alt = (params = {}, options = {}) => {
	return {
		de: de.zoi_card__image_alt,
		en: en.zoi_card__image_alt,
		es: es.zoi_card__image_alt,
		fr: fr.zoi_card__image_alt,
		it: it.zoi_card__image_alt,
		nl: nl.zoi_card__image_alt,
		pt: pt.zoi_card__image_alt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__see_on_map = (params = {}, options = {}) => {
	return {
		de: de.zoi_card__see_on_map,
		en: en.zoi_card__see_on_map,
		es: es.zoi_card__see_on_map,
		fr: fr.zoi_card__see_on_map,
		it: it.zoi_card__see_on_map,
		nl: nl.zoi_card__see_on_map,
		pt: pt.zoi_card__see_on_map
	}[options.languageTag ?? languageTag()]()
}

